import type { PixelGrid } from './AlienSprites';

// Re-export PixelGrid for convenience
export type { PixelGrid };

// 1 = primary color
// 2 = secondary color (shade)
// 3 = highlight
// 4 = dark/black
// 0 = transparent

export const UPGRADE_SPRITE_DIMENSIONAL_RIFT: PixelGrid = [
    // Portal/rift with energy edges - 16x16
    [0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 3, 1, 0, 0, 0, 0, 1, 3, 0, 0, 0, 0],
    [0, 0, 0, 3, 1, 0, 1, 1, 1, 1, 0, 1, 3, 0, 0, 0],
    [0, 0, 3, 1, 0, 1, 4, 4, 4, 4, 1, 0, 1, 3, 0, 0],
    [0, 3, 1, 0, 1, 4, 4, 3, 3, 4, 4, 1, 0, 1, 3, 0],
    [3, 1, 0, 1, 4, 4, 3, 3, 3, 3, 4, 4, 1, 0, 1, 3],
    [0, 0, 1, 4, 4, 3, 3, 4, 4, 3, 3, 4, 4, 1, 0, 0],
    [0, 0, 1, 4, 3, 3, 4, 4, 4, 4, 3, 3, 4, 1, 0, 0],
    [0, 0, 1, 4, 3, 3, 4, 4, 4, 4, 3, 3, 4, 1, 0, 0],
    [0, 0, 1, 4, 4, 3, 3, 4, 4, 3, 3, 4, 4, 1, 0, 0],
    [3, 1, 0, 1, 4, 4, 3, 3, 3, 3, 4, 4, 1, 0, 1, 3],
    [0, 3, 1, 0, 1, 4, 4, 3, 3, 4, 4, 1, 0, 1, 3, 0],
    [0, 0, 3, 1, 0, 1, 4, 4, 4, 4, 1, 0, 1, 3, 0, 0],
    [0, 0, 0, 3, 1, 0, 1, 1, 1, 1, 0, 1, 3, 0, 0, 0],
    [0, 0, 0, 0, 3, 1, 0, 0, 0, 0, 1, 3, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_VOID_PRISM: PixelGrid = [
    // Dark crystal with void energy - 16x16
    [0, 0, 0, 0, 0, 0, 0, 3, 3, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 3, 3, 3, 3, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 4, 4, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 2, 1, 4, 4, 1, 2, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 2, 4, 1, 4, 4, 1, 4, 2, 1, 0, 0, 0],
    [0, 0, 1, 2, 4, 2, 1, 3, 3, 1, 2, 4, 2, 1, 0, 0],
    [0, 1, 2, 4, 2, 2, 1, 3, 3, 1, 2, 2, 4, 2, 1, 0],
    [1, 2, 4, 2, 2, 2, 1, 3, 3, 1, 2, 2, 2, 4, 2, 1],
    [1, 2, 4, 2, 2, 2, 1, 3, 3, 1, 2, 2, 2, 4, 2, 1],
    [0, 1, 2, 4, 2, 2, 1, 1, 1, 1, 2, 2, 4, 2, 1, 0],
    [0, 0, 1, 2, 4, 2, 1, 2, 2, 1, 2, 4, 2, 1, 0, 0],
    [0, 0, 0, 1, 2, 4, 1, 1, 1, 1, 4, 2, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 2, 4, 2, 2, 4, 2, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 2, 4, 4, 2, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_CHRONAL_DUST: PixelGrid = [
    // Hourglass with flowing sand - 16x16
    [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
    [0, 0, 0, 1, 2, 2, 2, 3, 3, 2, 2, 2, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 2, 2, 3, 3, 2, 2, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 2, 3, 3, 2, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 3, 3, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 3, 3, 3, 3, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 3, 3, 3, 3, 3, 3, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 2, 3, 3, 2, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 2, 2, 3, 3, 2, 2, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 2, 2, 2, 3, 3, 2, 2, 2, 1, 0, 0, 0],
    [0, 0, 1, 2, 2, 2, 2, 3, 3, 2, 2, 2, 2, 1, 0, 0],
    [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_DARK_MATTER_WEAVER: PixelGrid = [
    // Cosmic loom weaving reality - 16x16
    [0, 3, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 3, 0],
    [0, 0, 3, 0, 0, 0, 1, 2, 2, 1, 0, 0, 0, 3, 0, 0],
    [0, 0, 0, 3, 0, 1, 0, 3, 3, 0, 1, 0, 3, 0, 0, 0],
    [0, 0, 0, 0, 3, 1, 0, 3, 3, 0, 1, 3, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 1, 1, 1, 4, 4, 4, 4, 4, 4, 1, 1, 1, 0, 0],
    [0, 1, 2, 2, 1, 4, 2, 3, 3, 2, 4, 1, 2, 2, 1, 0],
    [1, 2, 3, 3, 1, 4, 3, 4, 4, 3, 4, 1, 3, 3, 2, 1],
    [1, 2, 3, 3, 1, 4, 3, 4, 4, 3, 4, 1, 3, 3, 2, 1],
    [0, 1, 2, 2, 1, 4, 2, 3, 3, 2, 4, 1, 2, 2, 1, 0],
    [0, 0, 1, 1, 1, 4, 4, 4, 4, 4, 4, 1, 1, 1, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 3, 1, 0, 3, 3, 0, 1, 3, 0, 0, 0, 0],
    [0, 0, 0, 3, 0, 1, 0, 3, 3, 0, 1, 0, 3, 0, 0, 0],
    [0, 0, 3, 0, 0, 0, 1, 2, 2, 1, 0, 0, 0, 3, 0, 0],
    [0, 3, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 3, 0],
];

export const UPGRADE_SPRITE_ENTROPY_INJECTOR: PixelGrid = [
    // Syringe with chaotic fluid - 16x16
    [0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 3, 3, 3, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 2, 2, 2, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 4, 3, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 4, 4, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 4, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 4, 4, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 4, 3, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 4, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 2, 1, 2, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_TEMPORAL_SIPHON: PixelGrid = [
    // Time vortex with energy spiral - 16x16
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 3, 3, 3, 3, 3, 3, 3, 1, 1, 0, 0, 0],
    [0, 1, 3, 3, 2, 2, 0, 0, 0, 2, 2, 3, 3, 1, 0, 0],
    [1, 3, 3, 2, 0, 0, 0, 0, 0, 0, 0, 2, 3, 3, 1, 0],
    [1, 3, 2, 0, 0, 1, 1, 1, 1, 0, 0, 0, 2, 3, 1, 0],
    [1, 3, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 3, 1, 0],
    [1, 3, 0, 1, 3, 4, 4, 4, 4, 3, 1, 0, 0, 3, 1, 0],
    [1, 3, 0, 1, 3, 4, 4, 4, 4, 3, 1, 0, 0, 3, 1, 0],
    [1, 3, 0, 1, 3, 4, 4, 4, 4, 3, 1, 0, 0, 3, 1, 0],
    [1, 3, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 3, 1, 0],
    [1, 3, 2, 0, 0, 1, 1, 1, 1, 0, 0, 0, 2, 3, 1, 0],
    [1, 3, 3, 2, 0, 0, 0, 0, 0, 0, 0, 2, 3, 3, 1, 0],
    [0, 1, 3, 3, 2, 2, 0, 0, 0, 2, 2, 3, 3, 1, 0, 0],
    [0, 0, 1, 1, 3, 3, 3, 3, 3, 3, 3, 1, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_EVENT_HORIZON_SHIELD: PixelGrid = [
    // Energy shield barrier - 16x16
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 1, 3, 3, 3, 3, 3, 3, 1, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 2, 2, 3, 3, 2, 2, 3, 3, 1, 0, 0],
    [0, 1, 3, 3, 2, 0, 0, 2, 2, 0, 0, 2, 3, 3, 1, 0],
    [0, 1, 3, 2, 0, 0, 4, 4, 4, 4, 0, 0, 2, 3, 1, 0],
    [1, 3, 2, 0, 0, 4, 4, 3, 3, 4, 4, 0, 0, 2, 3, 1],
    [1, 3, 2, 0, 4, 4, 3, 0, 0, 3, 4, 4, 0, 2, 3, 1],
    [1, 3, 3, 2, 4, 3, 0, 0, 0, 0, 3, 4, 2, 3, 3, 1],
    [1, 3, 3, 2, 4, 3, 0, 0, 0, 0, 3, 4, 2, 3, 3, 1],
    [1, 3, 2, 0, 4, 4, 3, 0, 0, 3, 4, 4, 0, 2, 3, 1],
    [1, 3, 2, 0, 0, 4, 4, 3, 3, 4, 4, 0, 0, 2, 3, 1],
    [0, 1, 3, 2, 0, 0, 4, 4, 4, 4, 0, 0, 2, 3, 1, 0],
    [0, 1, 3, 3, 2, 0, 0, 2, 2, 0, 0, 2, 3, 3, 1, 0],
    [0, 0, 1, 3, 3, 2, 2, 3, 3, 2, 2, 3, 3, 1, 0, 0],
    [0, 0, 0, 1, 1, 3, 3, 3, 3, 3, 3, 1, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_COSMIC_FILAMENT: PixelGrid = [
    // Cosmic energy strands/filaments - 16x16
    [3, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 3, 0],
    [0, 0, 1, 3, 0, 0, 0, 0, 0, 0, 0, 3, 1, 0, 0, 0],
    [0, 3, 0, 1, 4, 0, 0, 0, 0, 0, 4, 1, 0, 3, 0, 0],
    [0, 0, 0, 0, 1, 4, 0, 0, 0, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 4, 3, 3, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 4, 4, 4, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 3, 4, 4, 3, 4, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 4, 3, 4, 3, 3, 4, 3, 4, 1, 0, 0, 0],
    [0, 0, 1, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 1, 0, 0],
    [0, 1, 4, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 4, 1, 0],
    [1, 4, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 4, 1],
    [1, 3, 4, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 4, 3, 1],
    [1, 4, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 4, 1],
    [1, 3, 4, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 4, 3, 1],
    [1, 4, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 4, 1],
    [1, 3, 4, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 4, 3, 1],
];

export const UPGRADE_SPRITE_NULL_SPACE_PROJECTOR: PixelGrid = [
    // Satellite dish projecting energy - 16x16
    [0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 3, 3, 3, 0, 0, 3, 3, 3, 0, 0, 0, 0],
    [0, 0, 0, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 0, 0, 0],
    [0, 0, 0, 0, 3, 3, 3, 3, 3, 3, 3, 3, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 3, 3, 3, 3, 3, 3, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 3, 3, 3, 3, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 2, 2, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 2, 4, 4, 2, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 2, 4, 4, 4, 4, 2, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 2, 4, 4, 3, 3, 4, 4, 2, 1, 0, 0, 0],
    [0, 0, 1, 2, 4, 4, 3, 4, 4, 3, 4, 4, 2, 1, 0, 0],
    [0, 1, 2, 4, 4, 4, 4, 3, 3, 4, 4, 4, 4, 2, 1, 0],
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    [0, 0, 0, 0, 0, 1, 2, 2, 2, 2, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 2, 2, 1, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_OMEGA_RELAY: PixelGrid = [
    // Energy transmission tower - 16x16
    [0, 0, 0, 0, 0, 0, 3, 1, 1, 3, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 3, 3, 1, 1, 3, 3, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 3, 3, 1, 4, 4, 1, 3, 3, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 4, 3, 3, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 4, 3, 3, 4, 4, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 3, 2, 2, 3, 4, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 4, 3, 2, 3, 3, 2, 3, 4, 1, 0, 0, 0],
    [0, 0, 0, 1, 4, 3, 2, 3, 3, 2, 3, 4, 1, 0, 0, 0],
    [0, 0, 1, 4, 3, 2, 3, 4, 4, 3, 2, 3, 4, 1, 0, 0],
    [0, 0, 1, 4, 3, 2, 3, 4, 4, 3, 2, 3, 4, 1, 0, 0],
    [0, 1, 4, 3, 2, 3, 4, 3, 3, 4, 3, 2, 3, 4, 1, 0],
    [0, 1, 4, 3, 2, 3, 4, 3, 3, 4, 3, 2, 3, 4, 1, 0],
    [1, 4, 3, 2, 3, 4, 3, 3, 3, 3, 4, 3, 2, 3, 4, 1],
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    [0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0],
    [0, 0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0],
];

export const UPGRADE_SPRITE_ADAPTIVE_EVOLUTION: PixelGrid = [
    // DNA double helix with mutations - 16x16
    [0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0],
    [0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 1, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 1, 2, 1, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 2, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 2, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 3, 0, 0, 1, 2, 1, 0, 0, 3, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 2, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 2, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 2, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 1, 2, 1, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 1, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0],
    [0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0],
    [3, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 3, 3, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_SYMBIOTIC_WEAPONS: PixelGrid = [
    // Organic bio-weapon - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 3, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 2, 2, 3, 3, 3, 3, 3, 3, 0, 0],
    [0, 0, 0, 0, 1, 2, 4, 4, 2, 3, 3, 3, 3, 3, 3, 0],
    [0, 0, 0, 1, 2, 4, 1, 1, 4, 2, 3, 3, 1, 1, 1, 0],
    [0, 0, 1, 2, 4, 1, 3, 3, 1, 4, 2, 3, 2, 2, 1, 0],
    [0, 1, 2, 4, 1, 3, 3, 3, 3, 1, 4, 2, 3, 2, 1, 0],
    [1, 2, 4, 1, 3, 3, 4, 4, 3, 3, 1, 4, 2, 1, 0, 0],
    [1, 4, 1, 3, 3, 4, 1, 1, 4, 3, 3, 1, 4, 1, 0, 0],
    [1, 1, 3, 3, 4, 1, 0, 0, 1, 4, 3, 3, 1, 0, 0, 0],
    [0, 1, 3, 4, 1, 0, 0, 0, 0, 1, 4, 3, 1, 0, 0, 0],
    [0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_REGENERATIVE_HULL: PixelGrid = [
    // Plated Hull - 16x16
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 1, 3, 3, 3, 3, 3, 1, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 3, 1, 1, 3, 1, 1, 3, 3, 1, 0, 0, 0],
    [0, 1, 3, 3, 1, 2, 2, 3, 2, 2, 1, 3, 3, 1, 0, 0],
    [0, 1, 3, 1, 2, 2, 2, 3, 2, 2, 2, 1, 3, 1, 0, 0],
    [1, 3, 1, 2, 2, 2, 2, 3, 2, 2, 2, 2, 1, 3, 1, 0],
    [1, 3, 1, 2, 2, 3, 3, 3, 3, 3, 2, 2, 1, 3, 1, 0],
    [1, 3, 3, 3, 3, 3, 4, 4, 4, 3, 3, 3, 3, 3, 1, 0],
    [1, 3, 1, 2, 2, 3, 4, 4, 4, 3, 2, 2, 1, 3, 1, 0],
    [1, 3, 1, 2, 2, 2, 3, 4, 3, 2, 2, 2, 1, 3, 1, 0],
    [0, 1, 3, 1, 2, 2, 2, 3, 2, 2, 2, 1, 3, 1, 0, 0],
    [0, 1, 3, 3, 1, 2, 2, 3, 2, 2, 1, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 1, 1, 3, 1, 1, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 1, 3, 3, 3, 3, 3, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_HIVE_MIND: PixelGrid = [
    // Connected neural network - 16x16
    [0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0],
    [0, 1, 3, 4, 3, 1, 0, 0, 0, 0, 1, 3, 4, 3, 1, 0],
    [0, 1, 3, 4, 3, 1, 2, 2, 2, 2, 1, 3, 4, 3, 1, 0],
    [0, 0, 1, 3, 1, 2, 0, 0, 0, 0, 2, 1, 3, 1, 0, 0],
    [0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0],
    [0, 0, 0, 0, 2, 0, 1, 3, 3, 1, 0, 2, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 4, 4, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 4, 4, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 4, 4, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 2, 0, 1, 3, 3, 1, 0, 2, 0, 0, 0, 0],
    [0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0],
    [0, 0, 1, 3, 1, 2, 0, 0, 0, 0, 2, 1, 3, 1, 0, 0],
    [0, 1, 3, 4, 3, 1, 2, 2, 2, 2, 1, 3, 4, 3, 1, 0],
    [0, 1, 3, 4, 3, 1, 0, 0, 0, 0, 1, 3, 4, 3, 1, 0],
    [0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_PERFECT_ORGANISM: PixelGrid = [
    // Perfect bio-mechanical organism - 16x16
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 1, 3, 3, 1, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 1, 4, 3, 3, 4, 1, 3, 3, 1, 0, 0],
    [0, 1, 3, 3, 1, 4, 4, 3, 3, 4, 4, 1, 3, 3, 1, 0],
    [1, 3, 3, 1, 4, 4, 3, 4, 4, 3, 4, 4, 1, 3, 3, 1],
    [1, 3, 1, 4, 4, 3, 4, 4, 4, 4, 3, 4, 4, 1, 3, 1],
    [1, 3, 1, 4, 3, 4, 4, 4, 4, 4, 4, 3, 4, 1, 3, 1],
    [1, 3, 1, 4, 3, 4, 4, 4, 4, 4, 4, 3, 4, 1, 3, 1],
    [1, 3, 1, 4, 4, 3, 4, 4, 4, 4, 3, 4, 4, 1, 3, 1],
    [1, 3, 3, 1, 4, 4, 3, 4, 4, 3, 4, 4, 1, 3, 3, 1],
    [0, 1, 3, 3, 1, 4, 4, 3, 3, 4, 4, 1, 3, 3, 1, 0],
    [0, 0, 1, 3, 3, 1, 4, 3, 3, 4, 1, 3, 3, 1, 0, 0],
    [0, 0, 0, 1, 3, 3, 1, 3, 3, 1, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_ELDRITCH_EVOLUTION: PixelGrid = [
    // Tentacles - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 1, 3, 3, 1, 0, 1, 3, 3, 1, 0, 0, 1, 1, 0, 0],
    [1, 3, 4, 4, 3, 1, 1, 3, 4, 3, 1, 1, 3, 3, 1, 0],
    [1, 3, 4, 4, 3, 3, 1, 3, 4, 4, 3, 3, 4, 4, 1, 0],
    [1, 3, 4, 4, 4, 3, 3, 3, 4, 4, 4, 4, 4, 3, 1, 0],
    [0, 1, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 1, 0, 0],
    [0, 0, 1, 3, 4, 4, 4, 4, 4, 4, 4, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 4, 4, 4, 4, 4, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 4, 4, 4, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 4, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_COSMIC_HORROR: PixelGrid = [
    // Eye in void - 16x16
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 1, 1, 4, 4, 4, 4, 4, 4, 4, 4, 1, 1, 0, 0],
    [0, 1, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 1, 0],
    [1, 4, 4, 4, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 1],
    [1, 4, 4, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 1],
    [1, 4, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 1],
    [1, 4, 3, 3, 3, 3, 1, 1, 1, 1, 3, 3, 3, 3, 4, 1],
    [1, 4, 3, 3, 3, 1, 4, 4, 4, 4, 1, 3, 3, 3, 4, 1],
    [1, 4, 3, 3, 3, 1, 4, 4, 4, 4, 1, 3, 3, 3, 4, 1],
    [1, 4, 3, 3, 3, 1, 4, 4, 4, 4, 1, 3, 3, 3, 4, 1],
    [1, 4, 3, 3, 3, 3, 1, 1, 1, 1, 3, 3, 3, 3, 4, 1],
    [1, 4, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 1],
    [1, 4, 4, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 1],
    [0, 1, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 1, 0],
    [0, 0, 1, 1, 4, 4, 4, 4, 4, 4, 4, 4, 1, 1, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_TRANSCENDENT_FORM: PixelGrid = [
    // Glowing silhouette - 16x16
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_LIVING_WEAPON: PixelGrid = [
    // Flesh sword - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 3, 1],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 3, 2, 1],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 3, 2, 1, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 3, 2, 1, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 3, 2, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 1, 3, 2, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 3, 2, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 2, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 2, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 4, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 4, 3, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 1, 4, 3, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [1, 4, 3, 4, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_APEX_PREDATOR: PixelGrid = [
    // T-Rex skull / Jaws - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 1, 1, 1, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 1, 4, 1, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 1, 1, 1, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 0, 0],
    [0, 0, 1, 3, 1, 0, 1, 0, 1, 0, 1, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 1, 1, 1, 1, 1, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_FUSION_REACTOR: PixelGrid = [
    // Sun / Atom - 16x16
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 3, 3, 3, 3, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 4, 4, 3, 3, 4, 4, 3, 3, 1, 0, 0],
    [0, 1, 3, 3, 4, 3, 3, 4, 4, 3, 3, 4, 3, 3, 1, 0],
    [0, 1, 3, 3, 4, 3, 3, 3, 3, 3, 3, 4, 3, 3, 1, 0],
    [1, 3, 3, 3, 3, 4, 3, 3, 3, 3, 4, 3, 3, 3, 3, 1],
    [1, 3, 3, 3, 3, 3, 4, 4, 4, 4, 3, 3, 3, 3, 3, 1],
    [1, 3, 3, 3, 3, 3, 4, 4, 4, 4, 3, 3, 3, 3, 3, 1],
    [1, 3, 3, 3, 3, 4, 3, 3, 3, 3, 4, 3, 3, 3, 3, 1],
    [0, 1, 3, 3, 4, 3, 3, 3, 3, 3, 3, 4, 3, 3, 1, 0],
    [0, 1, 3, 3, 4, 3, 3, 4, 4, 3, 3, 4, 3, 3, 1, 0],
    [0, 0, 1, 3, 3, 4, 4, 3, 3, 4, 4, 3, 3, 1, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 3, 3, 3, 3, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_ZERO_POINT: PixelGrid = [
    // Quantum singularity - 16x16
    [0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0],
    [0, 0, 0, 3, 0, 0, 1, 1, 1, 1, 0, 0, 3, 0, 0, 0],
    [0, 0, 3, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 3, 0, 0],
    [0, 3, 0, 0, 1, 3, 3, 4, 4, 3, 3, 1, 0, 0, 3, 0],
    [3, 0, 0, 1, 3, 3, 4, 4, 4, 4, 3, 3, 1, 0, 0, 3],
    [0, 0, 1, 3, 3, 4, 4, 4, 4, 4, 4, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 4, 4, 4, 4, 4, 4, 4, 4, 3, 1, 0, 0],
    [0, 0, 1, 3, 4, 4, 4, 4, 4, 4, 4, 4, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 4, 4, 4, 4, 4, 4, 3, 3, 1, 0, 0],
    [3, 0, 0, 1, 3, 3, 4, 4, 4, 4, 3, 3, 1, 0, 0, 3],
    [0, 3, 0, 0, 1, 3, 3, 4, 4, 3, 3, 1, 0, 0, 3, 0],
    [0, 0, 3, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 3, 0, 0],
    [0, 0, 0, 3, 0, 0, 1, 1, 1, 1, 0, 0, 3, 0, 0, 0],
    [0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_PERPETUAL_MOTION: PixelGrid = [
    // Rotating gears - 16x16
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 1, 1, 1, 1, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 1, 1, 3, 3, 3, 3, 1, 0, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0],
    [1, 3, 3, 3, 3, 4, 3, 3, 3, 3, 4, 3, 3, 3, 3, 1],
    [1, 3, 3, 3, 4, 4, 4, 3, 3, 4, 4, 4, 3, 3, 3, 1],
    [1, 1, 3, 3, 3, 4, 3, 3, 3, 3, 4, 3, 3, 3, 1, 1],
    [1, 1, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 1, 1],
    [1, 1, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 1, 1],
    [1, 1, 3, 3, 3, 4, 3, 3, 3, 3, 4, 3, 3, 3, 1, 1],
    [1, 3, 3, 3, 4, 4, 4, 3, 3, 4, 4, 4, 3, 3, 3, 1],
    [1, 3, 3, 3, 3, 4, 3, 3, 3, 3, 4, 3, 3, 3, 3, 1],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0],
    [0, 0, 1, 3, 3, 3, 3, 1, 1, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 0, 1, 3, 3, 1, 1, 1, 1, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_TESLA_COILS: PixelGrid = [
    // Tesla coil with electric arcs - 16x16
    [0, 0, 3, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 3, 0, 0],
    [0, 3, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 3, 0],
    [3, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 3],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 4, 4, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 4, 4, 3, 1, 0, 0, 0, 0, 0],
    [3, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 3],
    [0, 3, 0, 0, 0, 0, 1, 2, 2, 1, 0, 0, 0, 0, 3, 0],
    [0, 0, 3, 0, 0, 0, 1, 2, 2, 1, 0, 0, 0, 3, 0, 0],
    [3, 0, 0, 0, 0, 0, 1, 2, 2, 1, 0, 0, 0, 0, 0, 3],
    [0, 0, 0, 0, 0, 0, 1, 2, 2, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 2, 2, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0, 0],
    [0, 0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0],
    [0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0],
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
];

export const UPGRADE_SPRITE_ARC_REACTOR: PixelGrid = [
    // Arc Reactor - 16x16
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 1, 1, 1, 1, 1, 1, 3, 3, 1, 0, 0],
    [0, 1, 3, 3, 1, 4, 4, 4, 4, 4, 4, 1, 3, 3, 1, 0],
    [1, 3, 3, 1, 4, 4, 3, 3, 3, 4, 4, 1, 3, 3, 1],
    [1, 3, 1, 4, 4, 3, 3, 3, 3, 3, 4, 4, 1, 3, 1],
    [1, 3, 1, 4, 3, 3, 3, 4, 3, 3, 3, 4, 1, 3, 1],
    [1, 3, 1, 4, 3, 3, 4, 3, 4, 3, 3, 4, 1, 3, 1],
    [1, 3, 1, 4, 3, 3, 4, 3, 4, 3, 3, 4, 1, 3, 1],
    [1, 3, 1, 4, 3, 3, 3, 4, 3, 3, 3, 4, 1, 3, 1],
    [1, 3, 1, 4, 4, 3, 3, 3, 3, 3, 4, 4, 1, 3, 1],
    [1, 3, 3, 1, 4, 4, 3, 3, 3, 4, 4, 1, 3, 3, 1],
    [0, 1, 3, 3, 1, 4, 4, 4, 4, 4, 4, 1, 3, 3, 1, 0],
    [0, 0, 1, 3, 3, 1, 1, 1, 1, 1, 1, 3, 3, 1, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_HARVESTED_STAR: PixelGrid = [
    // Captured star with energy bars - 16x16
    [0, 0, 0, 0, 0, 3, 0, 3, 3, 0, 3, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 3, 0, 3, 3, 3, 3, 0, 3, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 3, 3, 3, 3, 3, 3, 0, 0, 0, 0, 0],
    [0, 0, 0, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 0, 0, 0],
    [0, 0, 1, 4, 4, 3, 3, 3, 3, 3, 3, 4, 4, 1, 0, 0],
    [0, 1, 2, 4, 2, 3, 3, 3, 3, 3, 3, 2, 4, 2, 1, 0],
    [1, 2, 2, 4, 2, 2, 3, 3, 3, 3, 2, 2, 4, 2, 2, 1],
    [1, 2, 2, 4, 2, 2, 2, 3, 3, 2, 2, 2, 4, 2, 2, 1],
    [1, 2, 2, 4, 2, 2, 2, 3, 3, 2, 2, 2, 4, 2, 2, 1],
    [1, 2, 2, 4, 2, 2, 3, 3, 3, 3, 2, 2, 4, 2, 2, 1],
    [0, 1, 2, 4, 2, 3, 3, 3, 3, 3, 3, 2, 4, 2, 1, 0],
    [0, 0, 1, 4, 4, 3, 3, 3, 3, 3, 3, 4, 4, 1, 0, 0],
    [0, 0, 0, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 0, 0, 0],
    [0, 0, 0, 0, 0, 3, 3, 3, 3, 3, 3, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 3, 0, 3, 3, 3, 3, 0, 3, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 3, 0, 3, 3, 0, 3, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_VACUUM_ENERGY_TAP: PixelGrid = [
    // Energy extraction funnel - 16x16
    [0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0],
    [0, 3, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 3, 0],
    [3, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 3],
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    [1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1],
    [1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1],
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    [0, 0, 0, 0, 0, 0, 1, 2, 2, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 2, 2, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 4, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 4, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 2, 4, 4, 2, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 2, 4, 4, 4, 4, 2, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 2, 4, 4, 4, 4, 4, 4, 2, 1, 0, 0, 0],
    [0, 0, 1, 2, 4, 4, 4, 4, 4, 4, 4, 4, 2, 1, 0, 0],
    [0, 1, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 1, 0],
];

export const UPGRADE_SPRITE_ENTROPY_REVERSAL_ENGINE: PixelGrid = [
    // Rewind symbol - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 1, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 1, 3, 1],
    [0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 1, 3, 3, 1],
    [0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 1, 3, 3, 3, 1],
    [0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 1, 3, 3, 3, 3, 1],
    [0, 0, 1, 3, 3, 3, 3, 3, 1, 1, 3, 3, 3, 3, 3, 1],
    [0, 1, 3, 3, 3, 3, 3, 3, 1, 3, 3, 3, 3, 3, 3, 1],
    [1, 3, 3, 3, 3, 3, 3, 3, 1, 3, 3, 3, 3, 3, 3, 1],
    [0, 1, 3, 3, 3, 3, 3, 3, 1, 3, 3, 3, 3, 3, 3, 1],
    [0, 0, 1, 3, 3, 3, 3, 3, 1, 1, 3, 3, 3, 3, 3, 1],
    [0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 1, 3, 3, 3, 3, 1],
    [0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 1, 3, 3, 3, 1],
    [0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 1, 3, 3, 1],
    [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 1, 3, 1],
];

export const UPGRADE_SPRITE_BIG_CRUNCH_GENERATOR: PixelGrid = [
    // Imploding circle - 16x16
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 3, 3, 3, 3, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0],
    [0, 1, 3, 3, 3, 3, 1, 1, 1, 1, 3, 3, 3, 3, 1, 0],
    [1, 3, 3, 3, 3, 1, 4, 4, 4, 4, 1, 3, 3, 3, 3, 1],
    [1, 3, 3, 3, 3, 1, 4, 0, 0, 4, 1, 3, 3, 3, 3, 1],
    [1, 3, 3, 3, 3, 1, 4, 0, 0, 4, 1, 3, 3, 3, 3, 1],
    [1, 3, 3, 3, 3, 1, 4, 4, 4, 4, 1, 3, 3, 3, 3, 1],
    [0, 1, 3, 3, 3, 3, 1, 1, 1, 1, 3, 3, 3, 3, 1, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 3, 3, 3, 3, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_MULTIVERSAL_TAP: PixelGrid = [
    // Multiple portals - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0],
    [1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0, 1, 3, 3, 3, 1],
    [1, 3, 4, 3, 1, 0, 0, 0, 0, 0, 0, 1, 3, 4, 3, 1],
    [1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0, 1, 3, 3, 3, 1],
    [0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 4, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0],
    [1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0, 1, 3, 3, 3, 1],
    [1, 3, 4, 3, 1, 0, 0, 0, 0, 0, 0, 1, 3, 4, 3, 1],
    [1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0, 1, 3, 3, 3, 1],
    [0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0],
];

export const UPGRADE_SPRITE_ANCIENT_TEXTS: PixelGrid = [
    // Ancient scroll with runes - 16x16
    [0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0],
    [0, 1, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 1, 0],
    [0, 1, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 1, 0],
    [0, 1, 2, 3, 4, 4, 4, 3, 3, 4, 4, 3, 3, 2, 1, 0],
    [0, 1, 2, 3, 3, 3, 4, 3, 3, 4, 3, 3, 3, 2, 1, 0],
    [0, 1, 2, 3, 3, 3, 4, 3, 3, 4, 4, 3, 3, 2, 1, 0],
    [0, 1, 2, 3, 3, 3, 4, 3, 3, 4, 3, 3, 3, 2, 1, 0],
    [0, 1, 2, 3, 4, 4, 4, 3, 3, 4, 4, 4, 3, 2, 1, 0],
    [0, 1, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 1, 0],
    [0, 1, 2, 3, 4, 4, 3, 3, 4, 3, 3, 4, 3, 2, 1, 0],
    [0, 1, 2, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 2, 1, 0],
    [0, 1, 2, 3, 4, 4, 4, 3, 4, 3, 3, 4, 3, 2, 1, 0],
    [0, 1, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 1, 0],
    [0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0],
    [0, 1, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 1, 0],
    [0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0],
];

export const UPGRADE_SPRITE_AKASHIC_RECORDS_LIBRARY: PixelGrid = [
    // Glowing book - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 0, 0, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 1, 1, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 4, 4, 3, 3, 3, 3, 4, 4, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 4, 4, 3, 3, 3, 3, 4, 4, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 4, 4, 3, 3, 3, 3, 4, 4, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 1, 1, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 0, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_PROPHETIC_VISION: PixelGrid = [
    // Mystical eye with energy - 16x16
    [0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0],
    [0, 0, 3, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 3, 0, 0],
    [0, 3, 0, 0, 1, 3, 3, 3, 3, 3, 3, 1, 0, 0, 3, 0],
    [3, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 3],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 1, 3, 3, 3, 1, 1, 1, 1, 1, 1, 3, 3, 3, 1, 0],
    [0, 1, 3, 3, 1, 2, 2, 2, 2, 2, 2, 1, 3, 3, 1, 0],
    [0, 1, 3, 3, 1, 2, 4, 4, 4, 4, 2, 1, 3, 3, 1, 0],
    [0, 1, 3, 3, 1, 2, 4, 3, 3, 4, 2, 1, 3, 3, 1, 0],
    [0, 1, 3, 3, 1, 2, 4, 4, 4, 4, 2, 1, 3, 3, 1, 0],
    [0, 1, 3, 3, 1, 2, 2, 2, 2, 2, 2, 1, 3, 3, 1, 0],
    [0, 1, 3, 3, 3, 1, 1, 1, 1, 1, 1, 3, 3, 3, 1, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [3, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 3],
    [0, 3, 0, 0, 1, 3, 3, 3, 3, 3, 3, 1, 0, 0, 3, 0],
    [0, 0, 3, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 3, 0, 0],
];

export const UPGRADE_SPRITE_UNIVERSAL_TRANSLATOR: PixelGrid = [
    // Speech bubble - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 4, 3, 4, 4, 3, 4, 4, 4, 3, 1, 0, 0],
    [0, 0, 1, 3, 4, 3, 4, 3, 3, 4, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 4, 3, 4, 4, 3, 4, 4, 4, 3, 1, 0, 0],
    [0, 0, 1, 3, 4, 3, 4, 3, 3, 4, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 4, 4, 4, 3, 3, 4, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 3, 3, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_OMNISCIENCE_LITE: PixelGrid = [
    // Glasses - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 0, 0],
    [0, 1, 3, 3, 3, 3, 3, 1, 1, 3, 3, 3, 3, 3, 1, 0],
    [1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1],
    [1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1],
    [1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1],
    [0, 1, 3, 3, 3, 3, 3, 1, 1, 3, 3, 3, 3, 3, 1, 0],
    [0, 0, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_FORBIDDEN_THEOREMS: PixelGrid = [
    // Glitched book - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0],
    [0, 1, 3, 4, 3, 4, 3, 4, 3, 4, 3, 4, 3, 3, 1, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0],
    [0, 1, 3, 4, 3, 4, 3, 4, 3, 4, 3, 4, 3, 3, 1, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0],
    [0, 1, 3, 4, 3, 4, 3, 4, 3, 4, 3, 4, 3, 3, 1, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0],
    [0, 1, 3, 4, 3, 4, 3, 4, 3, 4, 3, 4, 3, 3, 1, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0],
    [0, 1, 3, 4, 3, 4, 3, 4, 3, 4, 3, 4, 3, 3, 1, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0],
    [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_SCHRODINGER_UPGRADE: PixelGrid = [
    // Cat box - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 4, 4, 3, 4, 4, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 4, 4, 3, 4, 4, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 4, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 4, 4, 4, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_UNIVERSAL_CONSTANTS: PixelGrid = [
    // Pi / Math - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 1, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 1, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 1, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 1, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 1, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 1, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 1, 3, 3, 1, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_APOTHEOSIS: PixelGrid = [
    // Apotheosis divine ascension - 16x16
    [0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 4, 0, 0, 1, 4, 3, 4, 3, 4, 1, 0, 0, 4, 0, 0],
    [0, 0, 0, 0, 1, 3, 4, 3, 4, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 4, 0, 0, 0, 0, 1, 4, 1, 0, 0, 0, 0, 4, 0, 0],
    [0, 0, 0, 0, 0, 1, 4, 3, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 3, 4, 3, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 4, 0, 1, 3, 4, 3, 4, 3, 1, 0, 4, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 3, 4, 3, 4, 1, 0, 0, 0, 0, 0],
    [0, 4, 0, 0, 1, 3, 4, 3, 4, 3, 1, 0, 0, 4, 0, 0],
    [0, 0, 0, 0, 0, 1, 4, 3, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 4, 0, 0, 1, 1, 1, 0, 0, 4, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_OMNISCIENCE: PixelGrid = [
    // True omniscience all seeing eye - 16x16
    [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 4, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 4, 3, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 3, 4, 3, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 4, 3, 4, 3, 4, 3, 4, 1, 0, 0, 0, 0],
    [0, 0, 1, 4, 3, 4, 3, 4, 3, 4, 3, 4, 1, 0, 0, 0],
    [0, 1, 4, 3, 4, 3, 4, 3, 4, 3, 4, 3, 4, 1, 0, 0],
    [1, 4, 3, 4, 3, 1, 1, 4, 1, 1, 3, 4, 3, 4, 1, 0],
    [1, 4, 3, 4, 1, 4, 2, 4, 2, 4, 1, 4, 3, 4, 1, 0],
    [1, 4, 3, 4, 1, 4, 2, 4, 2, 4, 1, 4, 3, 4, 1, 0],
    [1, 4, 3, 4, 1, 4, 2, 4, 2, 4, 1, 4, 3, 4, 1, 0],
    [1, 4, 3, 4, 3, 1, 1, 4, 1, 1, 3, 4, 3, 4, 1, 0],
    [0, 1, 4, 3, 4, 3, 4, 3, 4, 3, 4, 3, 4, 1, 0, 0],
    [0, 0, 1, 4, 3, 4, 3, 4, 3, 4, 3, 4, 1, 0, 0, 0],
    [0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_DEATH_PACT: PixelGrid = [
    // Demonic skull - 16x16
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0, 0],
    [0, 0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0],
    [0, 1, 2, 2, 4, 4, 2, 2, 2, 4, 4, 2, 2, 2, 1, 0],
    [0, 1, 2, 4, 4, 4, 4, 2, 2, 4, 4, 4, 4, 2, 1, 0],
    [0, 1, 2, 4, 4, 3, 4, 2, 2, 4, 3, 4, 4, 2, 1, 0],
    [1, 2, 2, 4, 4, 4, 4, 2, 2, 4, 4, 4, 4, 2, 2, 1],
    [1, 2, 2, 2, 4, 4, 2, 2, 2, 2, 4, 4, 2, 2, 2, 1],
    [1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1],
    [1, 2, 2, 2, 2, 2, 4, 4, 4, 4, 2, 2, 2, 2, 2, 1],
    [0, 1, 2, 2, 2, 4, 4, 4, 4, 4, 4, 2, 2, 2, 1, 0],
    [0, 1, 2, 2, 2, 4, 4, 4, 4, 4, 4, 2, 2, 2, 1, 0],
    [0, 0, 1, 2, 2, 2, 4, 2, 2, 4, 2, 2, 2, 1, 0, 0],
    [0, 0, 0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_LASER_FOCUSING: PixelGrid = [
    // Lens focusing laser beam - 16x16
    [0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 3, 3, 3, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 3, 3, 2, 3, 3, 0, 0, 0, 0, 0, 0],
    [0, 1, 1, 1, 1, 1, 2, 2, 2, 1, 1, 1, 1, 1, 0, 0],
    [0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0],
    [1, 2, 3, 3, 3, 3, 3, 4, 3, 3, 3, 3, 3, 3, 2, 1],
    [1, 2, 3, 3, 3, 3, 3, 4, 3, 3, 3, 3, 3, 3, 2, 1],
    [1, 2, 3, 3, 3, 3, 3, 4, 3, 3, 3, 3, 3, 3, 2, 1],
    [1, 2, 3, 3, 3, 3, 3, 4, 3, 3, 3, 3, 3, 3, 2, 1],
    [1, 2, 3, 3, 3, 3, 3, 4, 3, 3, 3, 3, 3, 3, 2, 1],
    [1, 2, 3, 3, 3, 3, 3, 4, 3, 3, 3, 3, 3, 3, 2, 1],
    [0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0],
    [0, 1, 1, 1, 1, 1, 2, 2, 2, 1, 1, 1, 1, 1, 0, 0],
    [0, 0, 0, 0, 0, 3, 3, 2, 3, 3, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 3, 3, 3, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_COFFEE_MACHINE: PixelGrid = [
    // Coffee machine with cup - 16x16
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 2, 2, 2, 3, 3, 2, 2, 2, 1, 0, 0, 0],
    [0, 0, 0, 1, 2, 1, 1, 1, 1, 1, 1, 2, 1, 0, 0, 0],
    [0, 0, 0, 1, 2, 1, 4, 4, 4, 4, 1, 2, 1, 0, 0, 0],
    [0, 0, 0, 1, 2, 1, 4, 4, 4, 4, 1, 2, 1, 0, 0, 0],
    [0, 0, 0, 1, 2, 2, 1, 1, 1, 1, 2, 2, 1, 0, 0, 0],
    [0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 4, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 4, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 4, 4, 4, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 2, 2, 4, 4, 2, 2, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 2, 2, 4, 4, 2, 2, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 2, 2, 4, 4, 2, 2, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 2, 2, 2, 2, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_QUANTUM_TARGETING: PixelGrid = [
    // Crosshair - 16x16
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 0, 0, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 0, 0, 0, 0, 0, 0, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 0, 0, 0, 1, 1, 0, 0, 0, 3, 1, 0, 0],
    [0, 0, 1, 3, 0, 0, 1, 3, 3, 1, 0, 0, 3, 1, 0, 0],
    [1, 1, 1, 0, 0, 1, 3, 4, 4, 3, 1, 0, 0, 1, 1, 1],
    [1, 1, 1, 0, 0, 1, 3, 4, 4, 3, 1, 0, 0, 1, 1, 1],
    [0, 0, 1, 3, 0, 0, 1, 3, 3, 1, 0, 0, 3, 1, 0, 0],
    [0, 0, 1, 3, 0, 0, 0, 1, 1, 0, 0, 0, 3, 1, 0, 0],
    [0, 0, 0, 1, 3, 0, 0, 0, 0, 0, 0, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 0, 0, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_LUCKY_DICE: PixelGrid = [
    // Cosmic space dice with stars - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [4, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 4, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0],
    [1, 3, 3, 4, 3, 4, 3, 3, 3, 4, 3, 4, 3, 3, 2, 1],
    [1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 1],
    [1, 3, 3, 4, 3, 4, 3, 3, 3, 4, 3, 4, 3, 3, 2, 1],
    [1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 1],
    [1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 1],
    [1, 3, 3, 4, 3, 4, 3, 3, 3, 4, 3, 4, 3, 3, 2, 1],
    [1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 1],
    [1, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 1, 4],
    [0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0],
    [4, 0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0, 0],
    [0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 4, 0],
    [0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_ENERGY_RECYCLING: PixelGrid = [
    // Recycle arrows - 16x16
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0],
    [0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0],
    [1, 3, 3, 3, 3, 3, 1, 0, 0, 1, 3, 3, 3, 3, 3, 1],
    [0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0],
    [0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_OVERCLOCKED_REACTORS: PixelGrid = [
    // Overclocked glowing reactor - 16x16
    [3, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 3],
    [0, 0, 0, 3, 0, 1, 2, 2, 2, 2, 1, 0, 3, 0, 0, 0],
    [0, 0, 3, 0, 1, 2, 4, 3, 3, 4, 2, 1, 0, 3, 0, 0],
    [0, 3, 0, 1, 2, 4, 3, 4, 4, 3, 4, 2, 1, 0, 3, 0],
    [0, 0, 1, 2, 4, 3, 4, 3, 3, 4, 3, 4, 2, 1, 0, 0],
    [0, 1, 2, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 2, 1, 0],
    [1, 2, 4, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 4, 2, 1],
    [1, 2, 4, 3, 3, 4, 3, 4, 4, 3, 4, 3, 3, 4, 2, 1],
    [1, 2, 4, 3, 3, 4, 3, 4, 4, 3, 4, 3, 3, 4, 2, 1],
    [1, 2, 4, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 4, 2, 1],
    [0, 1, 2, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 2, 1, 0],
    [0, 0, 1, 2, 4, 3, 4, 3, 3, 4, 3, 4, 2, 1, 0, 0],
    [0, 3, 0, 1, 2, 4, 3, 4, 4, 3, 4, 2, 1, 0, 3, 0],
    [0, 0, 3, 0, 1, 2, 4, 3, 3, 4, 2, 1, 0, 3, 0, 0],
    [0, 0, 0, 3, 0, 1, 2, 2, 2, 2, 1, 0, 3, 0, 0, 0],
    [3, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 3],
];

export const UPGRADE_SPRITE_SHIP_SWARM: PixelGrid = [
    // Multiple ships in formation - 16x16
    [0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0],
    [0, 0, 1, 3, 1, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0],
    [0, 1, 2, 3, 2, 1, 0, 0, 1, 2, 3, 2, 1, 0, 0, 0],
    [0, 1, 3, 3, 3, 1, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 3, 0, 3, 0, 0, 0, 0, 3, 0, 3, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 2, 3, 2, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 3, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
    [1, 3, 1, 0, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0],
    [1, 2, 3, 1, 0, 0, 0, 0, 0, 1, 2, 3, 2, 1, 0, 0],
    [0, 1, 3, 1, 0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0],
    [0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 3, 0, 3, 0, 0, 0],
];

export const UPGRADE_SPRITE_FLEET_SYNERGY_MATRIX: PixelGrid = [
    // Connected ships with synergy network - 16x16
    [0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0],
    [0, 0, 1, 3, 1, 0, 1, 0, 1, 0, 1, 3, 1, 0, 0, 0],
    [0, 1, 2, 3, 2, 1, 0, 1, 0, 1, 2, 3, 2, 1, 0, 0],
    [0, 1, 3, 3, 3, 1, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0],
    [0, 0, 3, 0, 3, 0, 1, 0, 1, 0, 3, 0, 3, 0, 0, 0],
    [0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0],
    [0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0, 0, 0],
    [0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0],
    [0, 0, 3, 0, 3, 0, 1, 0, 1, 0, 3, 0, 3, 0, 0, 0],
    [0, 1, 3, 3, 3, 1, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0],
    [1, 2, 3, 2, 1, 0, 1, 0, 1, 0, 1, 2, 3, 2, 1, 0],
    [1, 3, 1, 0, 1, 0, 0, 1, 0, 0, 1, 0, 1, 3, 1, 0],
    [0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_QUANTUM_FLEET_SYNC: PixelGrid = [
    // Quantum synchronized fleet with energy waves - 16x16
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 1, 2, 2, 2, 2, 2, 2, 1, 1, 0, 0, 0],
    [0, 0, 1, 2, 3, 3, 3, 4, 3, 3, 3, 2, 1, 0, 0, 0],
    [0, 1, 2, 3, 4, 3, 4, 3, 4, 3, 4, 3, 2, 1, 0, 0],
    [0, 1, 3, 4, 3, 4, 3, 4, 3, 4, 3, 4, 3, 1, 0, 0],
    [1, 2, 3, 3, 4, 3, 4, 3, 4, 3, 4, 3, 3, 2, 1, 0],
    [1, 2, 3, 4, 3, 4, 3, 4, 3, 4, 3, 4, 3, 2, 1, 0],
    [1, 2, 3, 3, 4, 3, 4, 3, 4, 3, 4, 3, 3, 2, 1, 0],
    [1, 2, 3, 4, 3, 4, 3, 4, 3, 4, 3, 4, 3, 2, 1, 0],
    [1, 2, 3, 3, 4, 3, 4, 3, 4, 3, 4, 3, 3, 2, 1, 0],
    [0, 1, 3, 4, 3, 4, 3, 4, 3, 4, 3, 4, 3, 1, 0, 0],
    [0, 1, 2, 3, 4, 3, 4, 3, 4, 3, 4, 3, 2, 1, 0, 0],
    [0, 0, 1, 2, 3, 3, 3, 4, 3, 3, 3, 2, 1, 0, 0, 0],
    [0, 0, 0, 1, 1, 2, 2, 2, 2, 2, 2, 1, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_STELLAR_FUSION_CORE: PixelGrid = [
    // Stellar fusion core with radiating energy - 16x16
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 2, 2, 2, 2, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 2, 3, 3, 4, 4, 3, 3, 2, 1, 0, 0, 0],
    [0, 0, 1, 2, 3, 4, 4, 4, 4, 4, 4, 3, 2, 1, 0, 0],
    [0, 1, 2, 3, 4, 4, 4, 4, 4, 4, 4, 4, 3, 2, 1, 0],
    [0, 1, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 1, 0],
    [1, 2, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 2, 1],
    [1, 2, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 2, 1],
    [1, 2, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 2, 1],
    [1, 2, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 2, 1],
    [0, 1, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 1, 0],
    [0, 1, 2, 3, 4, 4, 4, 4, 4, 4, 4, 4, 3, 2, 1, 0],
    [0, 0, 1, 2, 3, 4, 4, 4, 4, 4, 4, 3, 2, 1, 0, 0],
    [0, 0, 0, 1, 2, 3, 3, 4, 4, 3, 3, 2, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 2, 2, 2, 2, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_QUANTUM_NETWORK_MATRIX: PixelGrid = [
    // Quantum network with three connection paths - 16x16
    [0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0],
    [0, 1, 2, 3, 2, 1, 0, 0, 0, 1, 2, 3, 2, 1, 0, 0],
    [1, 3, 3, 3, 3, 3, 1, 0, 1, 3, 3, 3, 3, 3, 1, 0],
    [0, 1, 3, 0, 3, 1, 0, 1, 0, 1, 3, 0, 3, 1, 0, 0],
    [0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0],
    [0, 0, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 0, 0, 0],
    [0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0],
    [0, 1, 3, 0, 3, 1, 0, 1, 0, 1, 3, 0, 3, 1, 0, 0],
    [1, 3, 3, 3, 3, 3, 1, 0, 1, 3, 3, 3, 3, 3, 1, 0],
    [0, 1, 2, 3, 2, 1, 0, 0, 0, 1, 2, 3, 2, 1, 0, 0],
    [0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_HYPER_NETWORK_ACCELERATOR: PixelGrid = [
    // Hyper accelerator with orange energy streams - 16x16
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 1, 2, 2, 2, 2, 2, 2, 1, 1, 0, 0, 0],
    [0, 0, 1, 2, 3, 3, 3, 4, 4, 3, 3, 3, 2, 1, 0, 0],
    [0, 1, 2, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 2, 1, 0],
    [0, 1, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 1, 0],
    [1, 2, 3, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 3, 2, 1],
    [1, 2, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 2, 1],
    [1, 2, 3, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 3, 2, 1],
    [1, 2, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 2, 1],
    [1, 2, 3, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 3, 2, 1],
    [0, 1, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 1, 0],
    [0, 1, 2, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 2, 1, 0],
    [0, 0, 1, 2, 3, 3, 3, 4, 4, 3, 3, 3, 2, 1, 0, 0],
    [0, 0, 0, 1, 1, 2, 2, 2, 2, 2, 2, 1, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_FLEET_XP_SYNERGY: PixelGrid = [
    // Fleet ships with XP synergy connections - 16x16
    [0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0],
    [0, 1, 2, 3, 2, 1, 0, 0, 0, 1, 2, 3, 2, 1, 0, 0],
    [1, 3, 3, 3, 3, 3, 1, 0, 1, 3, 3, 3, 3, 3, 1, 0],
    [0, 1, 3, 0, 3, 1, 0, 1, 0, 1, 3, 0, 3, 1, 0, 0],
    [0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0],
    [0, 0, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 0, 0, 0],
    [0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0],
    [0, 1, 3, 0, 3, 1, 0, 1, 0, 1, 3, 0, 3, 1, 0, 0],
    [1, 3, 3, 3, 3, 3, 1, 0, 1, 3, 3, 3, 3, 3, 1, 0],
    [0, 1, 2, 3, 2, 1, 0, 0, 0, 1, 2, 3, 2, 1, 0, 0],
    [0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_FLEET_OMEGA_CORE: PixelGrid = [
    // Ultimate fleet core with radiating power - 16x16
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 1, 1, 2, 2, 2, 2, 1, 1, 1, 0, 0, 0],
    [0, 0, 1, 2, 3, 3, 3, 4, 4, 3, 3, 3, 2, 1, 0, 0],
    [0, 1, 2, 3, 4, 4, 4, 3, 3, 4, 4, 4, 3, 2, 1, 0],
    [0, 1, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 1, 0],
    [0, 1, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 1, 0],
    [1, 2, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 2, 1],
    [1, 2, 4, 4, 4, 4, 4, 3, 3, 4, 4, 4, 4, 4, 2, 1],
    [1, 2, 4, 4, 4, 4, 4, 3, 3, 4, 4, 4, 4, 4, 2, 1],
    [1, 2, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 2, 1],
    [0, 1, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 1, 0],
    [0, 1, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 1, 0],
    [0, 1, 2, 3, 4, 4, 4, 3, 3, 4, 4, 4, 3, 2, 1, 0],
    [0, 0, 1, 2, 3, 3, 3, 4, 4, 3, 3, 3, 2, 1, 0, 0],
    [0, 0, 0, 1, 1, 1, 2, 2, 2, 2, 1, 1, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_CRITICAL_MASTERY: PixelGrid = [
    // Target with critical strike symbol - 16x16
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 4, 4, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 4, 3, 3, 4, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 4, 3, 1, 1, 3, 4, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 4, 3, 1, 2, 2, 1, 3, 4, 3, 1, 0, 0],
    [0, 1, 3, 4, 3, 1, 2, 3, 3, 2, 1, 3, 4, 3, 1, 0],
    [1, 3, 4, 3, 1, 2, 3, 4, 4, 3, 2, 1, 3, 4, 3, 1],
    [1, 3, 4, 3, 1, 2, 3, 4, 4, 3, 2, 1, 3, 4, 3, 1],
    [0, 1, 3, 4, 3, 1, 2, 3, 3, 2, 1, 3, 4, 3, 1, 0],
    [0, 0, 1, 3, 4, 3, 1, 2, 2, 1, 3, 4, 3, 1, 0, 0],
    [0, 0, 0, 1, 3, 4, 3, 1, 1, 3, 4, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 4, 3, 3, 4, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 4, 4, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_DUAL_NETWORK_EXPANSION: PixelGrid = [
    // Multiple network nodes with connections - 16x16
    [0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0],
    [0, 0, 1, 3, 1, 0, 0, 1, 1, 0, 1, 3, 1, 0, 0, 0],
    [0, 1, 2, 3, 2, 1, 0, 0, 0, 1, 2, 3, 2, 1, 0, 0],
    [1, 3, 3, 3, 3, 1, 0, 1, 1, 0, 3, 3, 3, 3, 1, 0],
    [0, 1, 3, 0, 3, 0, 1, 0, 0, 1, 0, 3, 0, 3, 1, 0],
    [0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0],
    [0, 0, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 0, 0, 0],
    [0, 1, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 1, 0, 0],
    [0, 1, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 1, 0, 0],
    [0, 0, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 0, 0, 0],
    [0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0],
    [0, 1, 3, 0, 3, 0, 1, 0, 0, 1, 0, 3, 0, 3, 1, 0],
    [1, 3, 3, 3, 3, 1, 0, 1, 1, 0, 3, 3, 3, 3, 1, 0],
    [0, 1, 2, 3, 2, 1, 0, 0, 0, 1, 2, 3, 2, 1, 0, 0],
    [0, 0, 1, 3, 1, 0, 0, 1, 1, 0, 1, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_NETWORK_WHITE_GLOW: PixelGrid = [
    // White glowing network pattern - 16x16
    [0, 0, 0, 0, 0, 0, 0, 3, 3, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 3, 1, 1, 3, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 3, 1, 3, 3, 1, 3, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 3, 1, 3, 1, 1, 3, 1, 3, 0, 0, 0, 0],
    [0, 0, 0, 3, 1, 3, 1, 3, 3, 1, 3, 1, 3, 0, 0, 0],
    [0, 0, 3, 1, 3, 1, 3, 1, 1, 3, 1, 3, 1, 3, 0, 0],
    [0, 3, 1, 3, 1, 3, 1, 3, 3, 1, 3, 1, 3, 1, 3, 0],
    [3, 1, 3, 1, 3, 1, 3, 1, 1, 3, 1, 3, 1, 3, 1, 3],
    [3, 1, 3, 1, 3, 1, 3, 1, 1, 3, 1, 3, 1, 3, 1, 3],
    [0, 3, 1, 3, 1, 3, 1, 3, 3, 1, 3, 1, 3, 1, 3, 0],
    [0, 0, 3, 1, 3, 1, 3, 1, 1, 3, 1, 3, 1, 3, 0, 0],
    [0, 0, 0, 3, 1, 3, 1, 3, 3, 1, 3, 1, 3, 0, 0, 0],
    [0, 0, 0, 0, 3, 1, 3, 1, 1, 3, 1, 3, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 3, 1, 3, 3, 1, 3, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 3, 1, 1, 3, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 3, 3, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_CRIMSON_NETWORK_PROTOCOL: PixelGrid = [
    // Crimson red network pattern - 16x16
    [0, 0, 0, 0, 0, 0, 0, 3, 3, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 3, 1, 1, 3, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 3, 1, 3, 3, 1, 3, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 3, 1, 3, 1, 1, 3, 1, 3, 0, 0, 0, 0],
    [0, 0, 0, 3, 1, 3, 1, 3, 3, 1, 3, 1, 3, 0, 0, 0],
    [0, 0, 3, 1, 3, 1, 3, 1, 1, 3, 1, 3, 1, 3, 0, 0],
    [0, 3, 1, 3, 1, 3, 1, 3, 3, 1, 3, 1, 3, 1, 3, 0],
    [3, 1, 3, 1, 3, 1, 3, 1, 1, 3, 1, 3, 1, 3, 1, 3],
    [3, 1, 3, 1, 3, 1, 3, 1, 1, 3, 1, 3, 1, 3, 1, 3],
    [0, 3, 1, 3, 1, 3, 1, 3, 3, 1, 3, 1, 3, 1, 3, 0],
    [0, 0, 3, 1, 3, 1, 3, 1, 1, 3, 1, 3, 1, 3, 0, 0],
    [0, 0, 0, 3, 1, 3, 1, 3, 3, 1, 3, 1, 3, 0, 0, 0],
    [0, 0, 0, 0, 3, 1, 3, 1, 1, 3, 1, 3, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 3, 1, 3, 3, 1, 3, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 3, 1, 1, 3, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 3, 3, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_ENHANCED_COMBAT_MATRIX: PixelGrid = [
    // Enhanced combat matrix with targeting grid - 16x16
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 1, 2, 2, 2, 2, 2, 2, 1, 1, 0, 0, 0],
    [0, 0, 1, 2, 3, 3, 2, 3, 3, 2, 3, 3, 2, 1, 0, 0],
    [0, 1, 2, 3, 4, 3, 2, 3, 3, 2, 3, 4, 3, 2, 1, 0],
    [0, 1, 3, 4, 3, 2, 3, 4, 4, 3, 2, 3, 4, 3, 1, 0],
    [1, 2, 3, 3, 2, 3, 4, 3, 3, 4, 3, 2, 3, 3, 2, 1],
    [1, 2, 3, 2, 3, 4, 3, 4, 4, 3, 4, 3, 2, 3, 2, 1],
    [1, 2, 3, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 3, 2, 1],
    [1, 2, 3, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 3, 2, 1],
    [1, 2, 3, 2, 3, 4, 3, 4, 4, 3, 4, 3, 2, 3, 2, 1],
    [1, 2, 3, 3, 2, 3, 4, 3, 3, 4, 3, 2, 3, 3, 2, 1],
    [0, 1, 3, 4, 3, 2, 3, 4, 4, 3, 2, 3, 4, 3, 1, 0],
    [0, 1, 2, 3, 4, 3, 2, 3, 3, 2, 3, 4, 3, 2, 1, 0],
    [0, 0, 1, 2, 3, 3, 2, 3, 3, 2, 3, 3, 2, 1, 0, 0],
    [0, 0, 0, 1, 1, 2, 2, 2, 2, 2, 2, 1, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_RAPID_FIRE_SATELLITE: PixelGrid = [
    // Rapid fire satellite with multiple missile launchers - 16x16
    [0, 0, 0, 0, 0, 0, 0, 3, 3, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 3, 1, 1, 3, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 3, 1, 3, 3, 1, 3, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 3, 1, 3, 1, 1, 3, 1, 3, 0, 0, 0, 0],
    [0, 0, 0, 3, 1, 3, 1, 3, 3, 1, 3, 1, 3, 0, 0, 0],
    [0, 0, 3, 1, 3, 1, 3, 1, 1, 3, 1, 3, 1, 3, 0, 0],
    [0, 3, 1, 3, 1, 3, 1, 3, 3, 1, 3, 1, 3, 1, 3, 0],
    [3, 1, 3, 1, 3, 1, 3, 1, 1, 3, 1, 3, 1, 3, 1, 3],
    [3, 1, 3, 1, 3, 1, 3, 1, 1, 3, 1, 3, 1, 3, 1, 3],
    [0, 3, 1, 3, 1, 3, 1, 3, 3, 1, 3, 1, 3, 1, 3, 0],
    [0, 0, 3, 1, 3, 1, 3, 1, 1, 3, 1, 3, 1, 3, 0, 0],
    [0, 0, 0, 3, 1, 3, 1, 3, 3, 1, 3, 1, 3, 0, 0, 0],
    [0, 0, 0, 0, 3, 1, 3, 1, 1, 3, 1, 3, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 3, 1, 3, 3, 1, 3, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 3, 1, 1, 3, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 3, 3, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_ORBITAL_SATELLITE: PixelGrid = [
    // Orbital satellite with solar panels and antennae - 16x16
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 2, 2, 2, 2, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 2, 3, 3, 3, 3, 2, 1, 0, 0, 0, 0],
    [0, 0, 1, 1, 2, 3, 4, 4, 4, 4, 3, 2, 1, 1, 0, 0],
    [0, 1, 2, 2, 3, 4, 3, 3, 3, 3, 4, 3, 2, 2, 1, 0],
    [1, 2, 3, 3, 4, 3, 2, 2, 2, 2, 3, 4, 3, 3, 2, 1],
    [1, 2, 3, 4, 3, 2, 1, 1, 1, 1, 2, 3, 4, 3, 2, 1],
    [1, 2, 3, 4, 3, 2, 1, 0, 0, 1, 2, 3, 4, 3, 2, 1],
    [1, 2, 3, 4, 3, 2, 1, 0, 0, 1, 2, 3, 4, 3, 2, 1],
    [1, 2, 3, 4, 3, 2, 1, 1, 1, 1, 2, 3, 4, 3, 2, 1],
    [1, 2, 3, 3, 4, 3, 2, 2, 2, 2, 3, 4, 3, 3, 2, 1],
    [0, 1, 2, 2, 3, 4, 3, 3, 3, 3, 4, 3, 2, 2, 1, 0],
    [0, 0, 1, 1, 2, 3, 4, 4, 4, 4, 3, 2, 1, 1, 0, 0],
    [0, 0, 0, 0, 1, 2, 3, 3, 3, 3, 2, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 2, 2, 2, 2, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_VOID_ESSENCE_CORE: PixelGrid = [
    // Void essence core with purple energy - 16x16
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 2, 2, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 2, 3, 3, 3, 3, 2, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 2, 3, 4, 4, 4, 4, 3, 2, 1, 0, 0, 0],
    [0, 0, 1, 2, 3, 4, 3, 4, 4, 3, 4, 3, 2, 1, 0, 0],
    [0, 1, 2, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 2, 1, 0],
    [0, 1, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 1, 0],
    [1, 2, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 2, 1],
    [1, 2, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 2, 1],
    [0, 1, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 1, 0],
    [0, 1, 2, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 2, 1, 0],
    [0, 0, 1, 2, 3, 4, 3, 4, 4, 3, 4, 3, 2, 1, 0, 0],
    [0, 0, 0, 1, 2, 3, 4, 4, 4, 4, 3, 2, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 2, 3, 3, 3, 3, 2, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 2, 2, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_COSMIC_SYNERGY_MATRIX: PixelGrid = [
    // Cosmic synergy with dual energy streams - 16x16
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 1, 2, 2, 3, 3, 2, 2, 1, 1, 0, 0, 0],
    [0, 0, 1, 2, 3, 3, 3, 4, 4, 3, 3, 3, 2, 1, 0, 0],
    [0, 1, 2, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 2, 1, 0],
    [0, 1, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 1, 0],
    [1, 2, 3, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 3, 2, 1],
    [1, 2, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 2, 1],
    [1, 2, 3, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 3, 2, 1],
    [1, 2, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 2, 1],
    [1, 2, 3, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 3, 2, 1],
    [0, 1, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 1, 0],
    [0, 1, 2, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 2, 1, 0],
    [0, 0, 1, 2, 3, 3, 3, 4, 4, 3, 3, 3, 2, 1, 0, 0],
    [0, 0, 0, 1, 1, 2, 2, 3, 3, 2, 2, 1, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_KNOWLEDGE_POWER_CONVERSION: PixelGrid = [
    // Knowledge core converting to power/damage - 16x16
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 1, 2, 2, 2, 2, 2, 2, 1, 1, 0, 0, 0],
    [0, 0, 1, 2, 3, 3, 3, 4, 4, 3, 3, 3, 2, 1, 0, 0],
    [0, 1, 2, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 2, 1, 0],
    [0, 1, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 1, 0],
    [1, 2, 3, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 3, 2, 1],
    [1, 2, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 2, 1],
    [1, 2, 3, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 3, 2, 1],
    [1, 2, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 2, 1],
    [1, 2, 3, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 3, 2, 1],
    [0, 1, 3, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 3, 1, 0],
    [0, 1, 2, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 2, 1, 0],
    [0, 0, 1, 2, 3, 3, 3, 4, 4, 3, 3, 3, 2, 1, 0, 0],
    [0, 0, 0, 1, 1, 2, 2, 2, 2, 2, 2, 1, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_AMPLIFIED_RESONANCE: PixelGrid = [
    // Resonance core with wave patterns - 16x16
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 1, 2, 2, 2, 2, 2, 2, 1, 1, 0, 0, 0],
    [0, 0, 1, 2, 3, 3, 3, 4, 3, 3, 3, 2, 1, 0, 0, 0],
    [0, 1, 2, 3, 4, 3, 4, 3, 4, 3, 4, 3, 2, 1, 0, 0],
    [0, 1, 3, 4, 3, 4, 3, 4, 3, 4, 3, 4, 3, 1, 0, 0],
    [1, 2, 3, 3, 4, 3, 4, 3, 4, 3, 4, 3, 3, 2, 1, 0],
    [1, 2, 3, 4, 3, 4, 3, 4, 3, 4, 3, 4, 3, 2, 1, 0],
    [1, 2, 3, 3, 4, 3, 4, 3, 4, 3, 4, 3, 3, 2, 1, 0],
    [1, 2, 3, 4, 3, 4, 3, 4, 3, 4, 3, 4, 3, 2, 1, 0],
    [1, 2, 3, 3, 4, 3, 4, 3, 4, 3, 4, 3, 3, 2, 1, 0],
    [0, 1, 3, 4, 3, 4, 3, 4, 3, 4, 3, 4, 3, 1, 0, 0],
    [0, 1, 2, 3, 4, 3, 4, 3, 4, 3, 4, 3, 2, 1, 0, 0],
    [0, 0, 1, 2, 3, 3, 3, 4, 3, 3, 3, 2, 1, 0, 0, 0],
    [0, 0, 0, 1, 1, 2, 2, 2, 2, 2, 2, 1, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_NEURAL_LINK: PixelGrid = [
    // Brain with neural connections - 16x16
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 2, 2, 3, 3, 3, 2, 2, 1, 0, 0, 0, 0],
    [0, 0, 1, 2, 3, 3, 3, 4, 3, 3, 3, 2, 1, 0, 0, 0],
    [0, 1, 2, 3, 3, 4, 3, 3, 4, 3, 3, 3, 2, 1, 0, 0],
    [1, 2, 3, 3, 4, 3, 4, 3, 3, 4, 3, 3, 3, 2, 1, 0],
    [1, 2, 3, 3, 3, 4, 3, 3, 3, 3, 4, 3, 3, 2, 1, 0],
    [1, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 1, 0],
    [1, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 1, 0],
    [1, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 1, 0],
    [0, 1, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 1, 0, 0],
    [0, 0, 1, 2, 3, 3, 3, 3, 3, 3, 3, 2, 1, 0, 0, 0],
    [0, 0, 0, 1, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 3, 3, 1, 0, 0, 0, 1, 3, 3, 0, 0, 0, 0],
    [0, 0, 0, 0, 3, 1, 2, 2, 2, 1, 3, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 2, 1, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_SPACE_PIZZA: PixelGrid = [
    // Pizza slice with toppings - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 1, 4, 4, 4, 4, 4, 4, 4, 4, 1, 0, 0, 0, 0, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 1, 3, 2, 3, 3, 3, 2, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 2, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 2, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 2, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 2, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 2, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 2, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_RUBBER_DUCK: PixelGrid = [
    // Duck - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 4, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_FALAFEL_ROLLO_SPECIAL: PixelGrid = [
    // Falafel wrap/burrito - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 4, 4, 4, 4, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 4, 2, 3, 2, 3, 4, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 2, 3, 2, 3, 2, 3, 4, 1, 0, 0],
    [0, 0, 0, 1, 4, 2, 3, 2, 3, 2, 3, 2, 4, 1, 0, 0],
    [0, 0, 1, 4, 2, 3, 2, 3, 2, 3, 2, 3, 4, 1, 0, 0],
    [0, 1, 4, 2, 3, 2, 3, 2, 3, 2, 3, 2, 4, 1, 0, 0],
    [0, 1, 4, 3, 2, 3, 2, 3, 2, 3, 2, 3, 4, 1, 0, 0],
    [0, 1, 4, 2, 3, 2, 3, 2, 3, 2, 3, 2, 4, 1, 0, 0],
    [0, 0, 1, 4, 3, 2, 3, 2, 3, 2, 3, 4, 1, 0, 0, 0],
    [0, 0, 0, 1, 4, 3, 2, 3, 2, 3, 4, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 3, 2, 3, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 4, 4, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_ANTIMATTER_ROUNDS: PixelGrid = [
    // Antimatter energy bullets - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0],
    [0, 0, 3, 1, 3, 0, 0, 0, 0, 0, 3, 1, 3, 0, 0, 0],
    [0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0],
    [0, 0, 1, 4, 4, 1, 0, 0, 0, 0, 1, 4, 4, 1, 0, 0],
    [0, 0, 1, 4, 4, 1, 0, 0, 0, 0, 1, 4, 4, 1, 0, 0],
    [0, 0, 1, 4, 4, 1, 0, 0, 0, 0, 1, 4, 4, 1, 0, 0],
    [0, 0, 1, 4, 4, 1, 0, 0, 0, 0, 1, 4, 4, 1, 0, 0],
    [0, 0, 1, 4, 4, 1, 0, 0, 0, 0, 1, 4, 4, 1, 0, 0],
    [0, 0, 1, 4, 4, 1, 0, 0, 0, 0, 1, 4, 4, 1, 0, 0],
    [0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0],
    [0, 0, 1, 2, 2, 1, 0, 0, 0, 0, 1, 2, 2, 1, 0, 0],
    [0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_MOTIVATIONAL_POSTERS: PixelGrid = [
    // Motivational poster with thumbs up - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 0, 0, 1, 1, 1, 0, 0, 0, 3, 1, 0, 0],
    [0, 0, 1, 3, 0, 1, 2, 2, 2, 1, 0, 0, 3, 1, 0, 0],
    [0, 0, 1, 3, 0, 1, 2, 2, 2, 1, 1, 1, 3, 1, 0, 0],
    [0, 0, 1, 3, 0, 1, 2, 2, 2, 2, 2, 1, 3, 1, 0, 0],
    [0, 0, 1, 3, 0, 1, 2, 2, 2, 2, 2, 1, 3, 1, 0, 0],
    [0, 0, 1, 3, 0, 0, 1, 2, 2, 2, 1, 0, 3, 1, 0, 0],
    [0, 0, 1, 3, 0, 0, 0, 1, 1, 1, 0, 0, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_WARP_CORE: PixelGrid = [
    // Vortex - 16x16
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 3, 3, 3, 3, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 1, 3, 3, 3, 1, 1, 1, 1, 1, 1, 3, 3, 3, 1, 0],
    [0, 1, 3, 3, 1, 4, 4, 4, 4, 4, 4, 1, 3, 3, 1, 0],
    [1, 3, 3, 3, 1, 4, 3, 3, 3, 3, 4, 1, 3, 3, 3, 1],
    [1, 3, 3, 3, 1, 4, 3, 3, 3, 3, 4, 1, 3, 3, 3, 1],
    [1, 3, 3, 3, 1, 4, 3, 3, 3, 3, 4, 1, 3, 3, 3, 1],
    [1, 3, 3, 3, 1, 4, 3, 3, 3, 3, 4, 1, 3, 3, 3, 1],
    [0, 1, 3, 3, 1, 4, 4, 4, 4, 4, 4, 1, 3, 3, 1, 0],
    [0, 1, 3, 3, 3, 1, 1, 1, 1, 1, 1, 3, 3, 3, 1, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 3, 3, 3, 3, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_DISCO_BALL: PixelGrid = [
    // Disco ball - 16x16
    [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 3, 3, 3, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 4, 3, 4, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 4, 3, 3, 4, 3, 3, 4, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 4, 3, 3, 3, 4, 3, 3, 1, 0, 0, 0],
    [0, 1, 3, 4, 3, 3, 4, 3, 4, 3, 3, 4, 3, 1, 0, 0],
    [0, 1, 3, 3, 4, 3, 3, 4, 3, 3, 4, 3, 3, 1, 0, 0],
    [0, 1, 3, 4, 3, 3, 4, 3, 4, 3, 3, 4, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 4, 3, 3, 3, 4, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 4, 3, 3, 4, 3, 3, 4, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 4, 3, 4, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 3, 3, 3, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_AI_OPTIMIZER: PixelGrid = [
    // AI microchip with circuit - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 0, 0],
    [0, 0, 1, 3, 1, 3, 3, 1, 3, 3, 1, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 1, 1, 1, 3, 3, 3, 3, 3, 3, 3, 1, 1, 1, 0, 0],
    [0, 1, 3, 1, 3, 4, 3, 4, 3, 4, 3, 1, 3, 1, 0, 0],
    [0, 1, 3, 1, 3, 3, 4, 3, 4, 3, 3, 1, 3, 1, 0, 0],
    [0, 0, 1, 1, 3, 4, 3, 4, 3, 4, 3, 1, 1, 0, 0, 0],
    [0, 1, 3, 1, 3, 3, 4, 3, 4, 3, 3, 1, 3, 1, 0, 0],
    [0, 1, 3, 1, 3, 4, 3, 4, 3, 4, 3, 1, 3, 1, 0, 0],
    [0, 0, 1, 1, 3, 3, 3, 3, 3, 3, 3, 1, 1, 0, 0, 0],
    [0, 1, 3, 1, 3, 3, 3, 3, 3, 3, 3, 1, 3, 1, 0, 0],
    [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
    [0, 0, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 0, 1, 3, 0, 1, 3, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_LUCKY_HORSESHOE: PixelGrid = [
    // Horseshoe - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0],
    [0, 0, 0, 1, 3, 3, 1, 0, 0, 1, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 1, 1, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_PERFECT_PRECISION: PixelGrid = [
    // Scope - 16x16
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 4, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 4, 0, 0, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 0, 0, 0, 0, 4, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 4, 0, 0, 1, 1, 0, 0, 4, 1, 0, 0, 0],
    [0, 0, 1, 4, 0, 0, 1, 3, 3, 1, 0, 0, 4, 1, 0, 0],
    [0, 1, 4, 0, 0, 1, 3, 4, 4, 3, 1, 0, 0, 4, 1, 0],
    [1, 4, 0, 0, 1, 3, 4, 3, 3, 4, 3, 1, 0, 0, 4, 1],
    [1, 4, 0, 0, 1, 3, 4, 3, 3, 4, 3, 1, 0, 0, 4, 1],
    [0, 1, 4, 0, 0, 1, 3, 4, 4, 3, 1, 0, 0, 4, 1, 0],
    [0, 0, 1, 4, 0, 0, 1, 3, 3, 1, 0, 0, 4, 1, 0, 0],
    [0, 0, 0, 1, 4, 0, 0, 1, 1, 0, 0, 4, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 0, 0, 0, 0, 4, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 4, 0, 0, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 4, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_ARCADE_MACHINE: PixelGrid = [
    // Retro arcade machine - 16x16
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 2, 2, 3, 3, 2, 2, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 2, 4, 4, 4, 4, 4, 4, 2, 1, 0, 0, 0],
    [0, 0, 0, 1, 2, 4, 3, 3, 3, 3, 4, 2, 1, 0, 0, 0],
    [0, 0, 0, 1, 2, 4, 3, 1, 1, 3, 4, 2, 1, 0, 0, 0],
    [0, 0, 0, 1, 2, 4, 3, 1, 1, 3, 4, 2, 1, 0, 0, 0],
    [0, 0, 0, 1, 2, 4, 3, 3, 3, 3, 4, 2, 1, 0, 0, 0],
    [0, 0, 0, 1, 2, 4, 4, 4, 4, 4, 4, 2, 1, 0, 0, 0],
    [0, 0, 1, 2, 2, 1, 1, 2, 2, 1, 1, 2, 2, 1, 0, 0],
    [0, 0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0],
    [0, 0, 1, 2, 2, 1, 2, 2, 2, 2, 1, 2, 2, 1, 0, 0],
    [0, 0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0],
    [0, 0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0],
    [0, 0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0],
    [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_VOID_CHANNELING: PixelGrid = [
    // Void energy channels - 16x16
    [0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0],
    [0, 3, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 3, 0],
    [3, 0, 0, 0, 0, 1, 3, 4, 3, 1, 0, 0, 0, 0, 0, 3],
    [0, 0, 0, 0, 1, 3, 4, 4, 4, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 4, 4, 4, 4, 4, 3, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 4, 4, 3, 4, 3, 4, 4, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 4, 3, 4, 4, 4, 3, 4, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 4, 4, 4, 4, 4, 4, 4, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 4, 4, 4, 4, 4, 4, 4, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 4, 3, 4, 4, 4, 3, 4, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 4, 4, 3, 4, 3, 4, 4, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 4, 4, 4, 4, 4, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 4, 4, 4, 3, 1, 0, 0, 0, 0, 0],
    [3, 0, 0, 0, 0, 1, 3, 4, 3, 1, 0, 0, 0, 0, 0, 3],
    [0, 3, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 3, 0],
    [0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0],
];

export const UPGRADE_SPRITE_CHAOS_EMERALDS: PixelGrid = [
    // Seven chaos emeralds - 16x16
    [0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0],
    [0, 1, 3, 1, 0, 0, 1, 3, 1, 0, 0, 1, 3, 1, 0, 0],
    [1, 3, 3, 3, 1, 1, 3, 3, 3, 1, 1, 3, 3, 3, 1, 0],
    [1, 3, 3, 3, 1, 1, 3, 3, 3, 1, 1, 3, 3, 3, 1, 0],
    [0, 1, 3, 1, 0, 0, 1, 3, 1, 0, 0, 1, 3, 1, 0, 0],
    [0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0],
    [0, 1, 3, 1, 0, 0, 1, 3, 1, 0, 0, 1, 3, 1, 0, 0],
    [1, 3, 3, 3, 1, 1, 3, 3, 3, 1, 1, 3, 3, 3, 1, 0],
    [1, 3, 3, 3, 1, 1, 3, 3, 3, 1, 1, 3, 3, 3, 1, 0],
    [0, 1, 3, 1, 0, 0, 1, 3, 1, 0, 0, 1, 3, 1, 0, 0],
    [0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_TIME_MACHINE: PixelGrid = [
    // Malfunctioning time machine - 16x16
    [0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0],
    [0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0],
    [0, 3, 0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 3, 0],
    [0, 0, 0, 0, 1, 2, 4, 4, 4, 4, 2, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 2, 4, 4, 2, 1, 0, 0, 0, 0, 0],
    [0, 3, 0, 0, 0, 0, 1, 2, 2, 1, 0, 0, 0, 0, 3, 0],
    [0, 0, 0, 0, 0, 0, 1, 4, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 3, 0, 0, 0, 1, 4, 4, 1, 0, 0, 0, 3, 0, 0],
    [0, 0, 0, 0, 0, 1, 2, 2, 2, 2, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 2, 4, 4, 4, 4, 2, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 2, 4, 3, 3, 3, 3, 4, 2, 1, 0, 0, 0],
    [0, 3, 0, 1, 2, 3, 4, 3, 3, 4, 3, 2, 1, 0, 3, 0],
    [0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0],
    [0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_NANOBOTS: PixelGrid = [
    // Nanobots - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0],
    [1, 3, 3, 1, 0, 0, 0, 1, 1, 0, 0, 0, 1, 3, 3, 1],
    [1, 3, 3, 1, 0, 0, 1, 3, 3, 1, 0, 0, 1, 3, 3, 1],
    [0, 1, 1, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 1, 1, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 1, 0, 0, 1, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 1, 0, 0, 1, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0],
    [1, 3, 3, 1, 0, 0, 0, 1, 1, 0, 0, 0, 1, 3, 3, 1],
    [1, 3, 3, 1, 0, 0, 1, 3, 3, 1, 0, 0, 1, 3, 3, 1],
    [0, 1, 1, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 1, 1, 0],
];

export const UPGRADE_SPRITE_PLASMA_MATRIX: PixelGrid = [
    // Plasma energy matrix grid - 16x16
    [0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0],
    [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0],
    [0, 1, 4, 3, 1, 3, 4, 1, 4, 3, 1, 3, 4, 1, 1, 0],
    [0, 1, 3, 4, 1, 4, 3, 1, 3, 4, 1, 4, 3, 1, 1, 0],
    [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0],
    [0, 1, 4, 3, 1, 3, 4, 1, 4, 3, 1, 3, 4, 1, 1, 0],
    [0, 1, 3, 4, 1, 4, 3, 1, 3, 4, 1, 4, 3, 1, 1, 0],
    [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0],
    [0, 1, 4, 3, 1, 3, 4, 1, 4, 3, 1, 3, 4, 1, 1, 0],
    [0, 1, 3, 4, 1, 4, 3, 1, 3, 4, 1, 4, 3, 1, 1, 0],
    [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0],
    [0, 1, 4, 3, 1, 3, 4, 1, 4, 3, 1, 3, 4, 1, 1, 0],
    [0, 1, 3, 4, 1, 4, 3, 1, 3, 4, 1, 4, 3, 1, 1, 0],
    [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0],
    [0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_HOLOGRAPHIC_DECOYS: PixelGrid = [
    // Holographic projection - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 4, 4, 4, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 4, 3, 3, 3, 3, 3, 4, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 4, 4, 3, 3, 3, 4, 4, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 4, 3, 4, 3, 4, 3, 4, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 4, 3, 3, 4, 3, 3, 4, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 4, 4, 3, 3, 3, 4, 4, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 4, 3, 4, 3, 4, 3, 4, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 4, 3, 3, 3, 3, 3, 4, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 4, 4, 4, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 1, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 1, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_TEMPORAL_ACCELERATION: PixelGrid = [
    // Fast forward - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 3, 1, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 3, 3, 1, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 1, 1, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 1, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 1, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 1, 1, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 3, 1, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 1, 3, 1, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_QUANTUM_ENTANGLEMENT: PixelGrid = [
    // Linked particles - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0],
    [0, 1, 3, 3, 3, 1, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0],
    [0, 1, 3, 3, 3, 1, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0],
    [0, 1, 3, 3, 3, 1, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0],
    [0, 1, 3, 3, 3, 1, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0],
    [0, 1, 3, 3, 3, 1, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0],
];

export const UPGRADE_SPRITE_PHILOSOPHERS_STONE: PixelGrid = [
    // Mystical philosopher's stone - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 4, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 4, 3, 3, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 3, 4, 4, 3, 4, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 4, 3, 4, 3, 3, 4, 3, 4, 1, 0, 0, 0],
    [0, 0, 1, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 1, 0, 0],
    [0, 1, 4, 3, 4, 3, 4, 3, 3, 4, 3, 4, 3, 4, 1, 0],
    [0, 1, 4, 3, 4, 3, 3, 4, 4, 3, 3, 4, 3, 4, 1, 0],
    [0, 0, 1, 4, 3, 4, 3, 3, 3, 3, 4, 3, 4, 1, 0, 0],
    [0, 0, 0, 1, 4, 3, 4, 3, 3, 4, 3, 4, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 3, 4, 4, 3, 4, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 4, 3, 3, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 4, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_STELLAR_FORGE: PixelGrid = [
    // Star forge anvil - 16x16
    [0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 4, 0, 0, 1, 2, 2, 2, 2, 1, 0, 0, 4, 0, 0],
    [0, 0, 0, 0, 1, 2, 3, 3, 3, 3, 2, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 2, 3, 4, 4, 3, 2, 1, 0, 0, 0, 0],
    [0, 4, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 4, 0],
    [0, 0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0],
    [0, 1, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 1, 0],
    [0, 1, 2, 3, 4, 3, 3, 3, 3, 3, 3, 4, 3, 2, 1, 0],
    [0, 1, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 1, 0],
    [0, 0, 1, 2, 3, 3, 3, 3, 3, 3, 3, 3, 2, 1, 0, 0],
    [0, 0, 0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0],
    [0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_GOLDEN_GOOSE: PixelGrid = [
    // Quantum golden goose - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 4, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 4, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 4, 0, 0, 1, 4, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 4, 4, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 4, 4, 4, 4, 1, 0, 0, 0],
    [0, 4, 0, 0, 1, 4, 4, 4, 4, 4, 4, 4, 4, 1, 0, 0],
    [0, 0, 0, 1, 4, 4, 3, 4, 4, 4, 4, 4, 4, 1, 0, 0],
    [0, 0, 1, 4, 4, 4, 4, 4, 4, 4, 4, 4, 1, 0, 0, 0],
    [0, 4, 1, 4, 4, 4, 4, 4, 4, 4, 4, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 4, 4, 4, 4, 4, 4, 1, 0, 0, 4, 0, 0],
    [0, 0, 0, 0, 1, 4, 4, 4, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_DARK_MATTER_ENGINE: PixelGrid = [
    // Dark matter engine core - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 3, 0, 1, 1, 1, 1, 1, 1, 0, 3, 0, 0, 0],
    [0, 0, 0, 0, 1, 2, 2, 2, 2, 2, 2, 1, 0, 0, 0, 0],
    [0, 3, 0, 1, 2, 4, 3, 4, 4, 3, 4, 2, 1, 0, 3, 0],
    [0, 0, 1, 2, 4, 3, 4, 3, 3, 4, 3, 4, 2, 1, 0, 0],
    [0, 0, 1, 2, 4, 3, 3, 4, 4, 3, 3, 4, 2, 1, 0, 0],
    [0, 1, 2, 4, 3, 4, 3, 3, 3, 3, 4, 3, 4, 2, 1, 0],
    [0, 1, 2, 4, 3, 3, 4, 3, 3, 4, 3, 3, 4, 2, 1, 0],
    [0, 1, 2, 4, 3, 3, 4, 3, 3, 4, 3, 3, 4, 2, 1, 0],
    [0, 1, 2, 4, 3, 4, 3, 3, 3, 3, 4, 3, 4, 2, 1, 0],
    [0, 0, 1, 2, 4, 3, 3, 4, 4, 3, 3, 4, 2, 1, 0, 0],
    [0, 0, 1, 2, 4, 3, 4, 3, 3, 4, 3, 4, 2, 1, 0, 0],
    [0, 3, 0, 1, 2, 4, 3, 4, 4, 3, 4, 2, 1, 0, 3, 0],
    [0, 0, 0, 0, 1, 2, 2, 2, 2, 2, 2, 1, 0, 0, 0, 0],
    [0, 0, 0, 3, 0, 1, 1, 1, 1, 1, 1, 0, 3, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_SHIP: PixelGrid = [
    // Spaceship - 16x16
    [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 4, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 4, 4, 4, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 4, 4, 4, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 1, 1, 1, 1, 1, 3, 3, 1, 0, 0, 0],
    [0, 1, 3, 3, 1, 0, 0, 1, 0, 0, 1, 3, 3, 1, 0, 0],
    [0, 1, 3, 1, 0, 0, 0, 1, 0, 0, 0, 1, 3, 1, 0, 0],
    [1, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0],
    [1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_ATTACK_SPEED: PixelGrid = [
    // Lightning - 16x16
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 1, 3, 3, 3, 3, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 1, 1, 1, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_POINT_MULTIPLIER: PixelGrid = [
    // Diamond - 16x16
    [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0],
    [1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_CRIT_CHANCE: PixelGrid = [
    // Target/Sparkle - 16x16
    [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 1, 3, 1, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 3, 1, 0, 3, 0, 1, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 1, 0, 0, 3, 0, 0, 1, 3, 1, 0, 0, 0],
    [0, 1, 3, 3, 3, 3, 3, 4, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 1, 0, 0, 3, 0, 0, 1, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 1, 0, 3, 0, 1, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 1, 3, 1, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_RESOURCE_GEN: PixelGrid = [
    // Factory/Gear - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 4, 4, 4, 4, 4, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 4, 3, 3, 3, 4, 3, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 4, 3, 3, 3, 3, 3, 4, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 4, 3, 3, 3, 3, 3, 4, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 4, 3, 3, 3, 3, 3, 4, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 4, 3, 3, 3, 3, 3, 4, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 4, 3, 3, 3, 3, 3, 4, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 4, 3, 3, 3, 4, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 4, 4, 4, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_XP_BOOST: PixelGrid = [
    // Book/Up arrow - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 0, 0, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 1, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 1, 0, 0],
    [0, 1, 3, 4, 3, 3, 3, 3, 3, 3, 3, 4, 3, 1, 0, 0],
    [0, 1, 3, 4, 3, 3, 3, 3, 3, 3, 3, 4, 3, 1, 0, 0],
    [0, 1, 3, 4, 3, 3, 3, 3, 3, 3, 3, 4, 3, 1, 0, 0],
    [0, 1, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 1, 0, 0],
    [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0],
];

export const UPGRADE_SPRITE_MUTATION_ENGINE: PixelGrid = [
    // DNA - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0],
    [0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0],
    [0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0],
    [0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 1, 1, 1, 1, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 1, 1, 1, 1, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0],
    [0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0],
    [0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_ENERGY_CORE: PixelGrid = [
    // Battery/Core - 16x16
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 4, 4, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 4, 3, 3, 4, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 4, 3, 3, 4, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 4, 3, 3, 4, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 4, 3, 3, 4, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 4, 3, 3, 4, 3, 3, 3, 1, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 4, 4, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_COSMIC_KNOWLEDGE: PixelGrid = [
    // Galaxy/Brain - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 1, 1, 1, 1, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 1, 4, 4, 4, 4, 1, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 1, 4, 3, 3, 4, 1, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 1, 4, 3, 3, 4, 1, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 1, 4, 3, 3, 4, 1, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 1, 4, 4, 4, 4, 1, 3, 3, 1, 0, 0],
    [0, 0, 0, 1, 3, 3, 1, 1, 1, 1, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_MISC: PixelGrid = [
    // Microscope/Question mark - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 1, 1, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_ANTIMATTER_CASCADE: PixelGrid = [
    // Antimatter cascade reactor - 16x16
    [0, 0, 0, 0, 0, 0, 3, 0, 0, 3, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 3, 1, 2, 2, 2, 2, 2, 2, 2, 2, 1, 3, 0, 0],
    [0, 0, 1, 2, 4, 4, 4, 4, 4, 4, 4, 2, 1, 0, 0, 0],
    [0, 0, 1, 2, 4, 3, 4, 3, 3, 4, 3, 4, 2, 1, 0, 0],
    [0, 0, 1, 2, 4, 4, 3, 4, 4, 3, 4, 4, 2, 1, 0, 0],
    [0, 3, 1, 2, 4, 3, 4, 3, 3, 4, 3, 4, 2, 1, 3, 0],
    [0, 0, 1, 2, 4, 4, 3, 4, 4, 3, 4, 4, 2, 1, 0, 0],
    [0, 0, 1, 2, 4, 3, 4, 3, 3, 4, 3, 4, 2, 1, 0, 0],
    [0, 0, 1, 2, 4, 4, 4, 4, 4, 4, 4, 2, 1, 0, 0, 0],
    [0, 0, 3, 1, 2, 2, 2, 2, 2, 2, 2, 2, 1, 3, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 3, 0, 0, 3, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_INFINITY_GAUNTLET: PixelGrid = [
    // Infinity gauntlet with gems - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 4, 1, 1, 4, 1, 1, 4, 1, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 1, 3, 3, 1, 3, 3, 1, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 1, 3, 3, 1, 3, 3, 1, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 1, 3, 3, 1, 3, 3, 1, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 0, 1, 3, 3, 4, 3, 4, 3, 4, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 2, 3, 2, 3, 2, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 4, 3, 4, 3, 4, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 2, 3, 2, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 0, 1, 3, 3, 4, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 2, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_NEBULA_HARVESTER: PixelGrid = [
    // Nebula energy harvester - 16x16
    [0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 3, 0, 1, 1, 4, 4, 4, 4, 1, 1, 0, 3, 0, 0],
    [0, 0, 0, 1, 4, 4, 3, 4, 4, 3, 4, 4, 1, 0, 0, 0],
    [0, 0, 1, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 1, 0, 0],
    [0, 0, 1, 4, 4, 3, 4, 3, 3, 4, 3, 4, 4, 1, 0, 0],
    [0, 3, 1, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 1, 3, 0],
    [0, 0, 1, 4, 4, 3, 4, 3, 3, 4, 3, 4, 4, 1, 0, 0],
    [0, 0, 1, 4, 3, 4, 3, 4, 4, 3, 4, 3, 4, 1, 0, 0],
    [0, 0, 0, 1, 4, 4, 3, 4, 4, 3, 4, 4, 1, 0, 0, 0],
    [0, 0, 3, 0, 1, 1, 4, 4, 4, 4, 1, 1, 0, 3, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_ALIEN_COOKBOOK: PixelGrid = [
    // Book - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_HYPER_REACTOR: PixelGrid = [
    // Hyper dimensional reactor - 16x16
    [0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 2, 2, 2, 2, 2, 1, 0, 0, 0, 0, 0],
    [0, 4, 0, 1, 2, 4, 3, 4, 4, 3, 4, 2, 1, 0, 4, 0],
    [0, 0, 1, 2, 4, 3, 4, 3, 3, 4, 3, 4, 2, 1, 0, 0],
    [0, 0, 1, 2, 4, 3, 4, 3, 3, 4, 3, 4, 2, 1, 0, 0],
    [0, 0, 1, 2, 4, 4, 3, 4, 4, 3, 4, 4, 2, 1, 0, 0],
    [0, 0, 1, 2, 4, 3, 4, 4, 4, 4, 3, 4, 2, 1, 0, 0],
    [0, 0, 1, 2, 4, 4, 3, 4, 4, 3, 4, 4, 2, 1, 0, 0],
    [0, 0, 1, 2, 4, 3, 4, 3, 3, 4, 3, 4, 2, 1, 0, 0],
    [0, 4, 0, 1, 2, 4, 3, 4, 4, 3, 4, 2, 1, 0, 4, 0],
    [0, 0, 0, 0, 1, 2, 2, 2, 2, 2, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_FLEET_COMMAND_CENTER: PixelGrid = [
    // Fleet command radar tower - 16x16
    [0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0],
    [0, 0, 3, 0, 3, 0, 0, 0, 0, 0, 0, 3, 0, 3, 0, 0],
    [0, 0, 1, 3, 0, 3, 0, 0, 0, 0, 3, 0, 3, 1, 0, 0],
    [0, 0, 1, 1, 3, 0, 3, 0, 0, 3, 0, 3, 1, 1, 0, 0],
    [0, 0, 1, 2, 1, 3, 0, 0, 0, 0, 3, 1, 2, 1, 0, 0],
    [0, 0, 1, 2, 2, 1, 0, 0, 0, 0, 1, 2, 2, 1, 0, 0],
    [0, 0, 1, 2, 2, 2, 1, 1, 1, 1, 2, 2, 2, 1, 0, 0],
    [0, 0, 1, 2, 2, 2, 3, 3, 3, 3, 2, 2, 2, 1, 0, 0],
    [0, 0, 0, 1, 2, 2, 3, 4, 4, 3, 2, 2, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 2, 2, 3, 3, 2, 2, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 2, 2, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 2, 2, 2, 2, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_QUANTUM_SINGULARITY: PixelGrid = [
    // Black hole - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 4, 4, 4, 4, 4, 3, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 4, 1, 1, 1, 1, 4, 3, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 4, 1, 0, 0, 1, 4, 3, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 4, 1, 0, 0, 1, 4, 3, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 4, 1, 1, 1, 1, 4, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 4, 4, 4, 4, 4, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_ARMADA_COMMAND: PixelGrid = [
    // Multiple ships - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0],
    [0, 1, 3, 1, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0],
    [1, 3, 3, 3, 1, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0],
    [0, 1, 3, 1, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0],
    [0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_CHRONOS_ACCELERATOR: PixelGrid = [
    // Chronos accelerator hourglass - 16x16
    [0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 3, 0, 1, 2, 4, 4, 4, 4, 2, 1, 0, 3, 0, 0],
    [0, 0, 0, 0, 0, 1, 2, 4, 4, 2, 1, 0, 0, 0, 0, 0],
    [0, 3, 0, 0, 0, 0, 1, 2, 2, 1, 0, 0, 0, 0, 3, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 3, 0, 0, 0, 1, 1, 0, 0, 0, 3, 0, 0, 0],
    [0, 0, 3, 0, 0, 0, 1, 2, 2, 1, 0, 0, 0, 3, 0, 0],
    [0, 0, 0, 0, 0, 1, 2, 4, 4, 2, 1, 0, 0, 0, 0, 0],
    [0, 3, 0, 0, 1, 2, 4, 3, 3, 4, 2, 1, 0, 0, 3, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_PERFECT_CRITICAL: PixelGrid = [
    // Target/Crosshair - 16x16
    [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 1, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 1, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 1, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 1, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 1, 1, 1, 1, 1, 1, 4, 1, 1, 1, 1, 1, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 1, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 1, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 1, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 1, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_INFINITE_KNOWLEDGE: PixelGrid = [
    // Infinity symbol - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 1, 1, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 1, 0, 1, 3, 3, 3, 1, 0, 0, 0],
    [0, 1, 3, 3, 3, 3, 3, 1, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 1, 0, 1, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 1, 1, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_NUCLEAR_REACTOR: PixelGrid = [
    // Pocket nuclear reactor - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0, 0],
    [0, 0, 1, 2, 3, 3, 1, 1, 1, 1, 3, 3, 2, 1, 0, 0],
    [0, 0, 1, 2, 3, 1, 4, 4, 4, 4, 1, 3, 2, 1, 0, 0],
    [0, 0, 1, 2, 1, 4, 3, 4, 4, 3, 4, 1, 2, 1, 0, 0],
    [0, 0, 1, 2, 1, 4, 4, 3, 3, 4, 4, 1, 2, 1, 0, 0],
    [0, 0, 1, 2, 1, 4, 4, 3, 3, 4, 4, 1, 2, 1, 0, 0],
    [0, 0, 1, 2, 1, 4, 4, 3, 3, 4, 4, 1, 2, 1, 0, 0],
    [0, 0, 1, 2, 1, 4, 3, 4, 4, 3, 4, 1, 2, 1, 0, 0],
    [0, 0, 1, 2, 3, 1, 4, 4, 4, 4, 1, 3, 2, 1, 0, 0],
    [0, 0, 1, 2, 3, 3, 1, 1, 1, 1, 3, 3, 2, 1, 0, 0],
    [0, 0, 0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_PHOTON_AMPLIFIER: PixelGrid = [
    // Photon wave amplifier - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [1, 1, 0, 0, 0, 4, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0],
    [1, 4, 1, 0, 1, 1, 1, 0, 0, 1, 1, 1, 0, 0, 0, 0],
    [1, 3, 1, 1, 3, 3, 3, 1, 1, 3, 3, 3, 1, 0, 0, 0],
    [1, 4, 1, 1, 4, 3, 4, 1, 1, 4, 3, 4, 1, 0, 0, 0],
    [0, 1, 4, 1, 3, 4, 3, 1, 1, 3, 4, 3, 1, 0, 0, 0],
    [0, 0, 1, 4, 4, 3, 4, 1, 1, 4, 3, 4, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 4, 3, 1, 1, 3, 4, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 4, 1, 1, 4, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 1, 1, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 4, 4, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_REALITY_ANCHOR: PixelGrid = [
    // Anchor - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 1, 1, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 1, 1, 0],
    [0, 1, 3, 1, 0, 0, 0, 1, 1, 0, 0, 0, 1, 3, 1, 0],
    [0, 0, 1, 3, 1, 1, 1, 3, 3, 1, 1, 1, 3, 1, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 3, 3, 3, 3, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_COSMIC_BATTERY: PixelGrid = [
    // Cosmic energy battery - 16x16
    [0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 2, 2, 2, 2, 1, 0, 0, 0, 0, 0],
    [0, 3, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 3, 0],
    [0, 0, 0, 1, 2, 4, 3, 4, 4, 3, 4, 2, 1, 0, 0, 0],
    [0, 0, 1, 2, 4, 3, 4, 3, 3, 4, 3, 4, 2, 1, 0, 0],
    [0, 0, 1, 2, 4, 4, 3, 4, 4, 3, 4, 4, 2, 1, 0, 0],
    [0, 3, 1, 2, 4, 3, 4, 3, 3, 4, 3, 4, 2, 1, 3, 0],
    [0, 0, 1, 2, 4, 4, 3, 4, 4, 3, 4, 4, 2, 1, 0, 0],
    [0, 0, 1, 2, 4, 3, 4, 3, 3, 4, 3, 4, 2, 1, 0, 0],
    [0, 0, 0, 1, 2, 4, 3, 4, 4, 3, 4, 2, 1, 0, 0, 0],
    [0, 3, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 3, 0],
    [0, 0, 0, 0, 0, 1, 2, 2, 2, 2, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_SINGULARITY_CORE: PixelGrid = [
    // Core/Orb - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 4, 4, 4, 4, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 4, 1, 1, 1, 1, 4, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 4, 1, 0, 0, 1, 4, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 4, 1, 0, 0, 1, 4, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 4, 1, 1, 1, 1, 4, 3, 3, 1, 0, 0],
    [0, 0, 0, 1, 3, 3, 4, 4, 4, 4, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_CHEAT_CODES: PixelGrid = [
    // Controller - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0],
    [0, 1, 3, 1, 3, 3, 3, 3, 3, 3, 3, 1, 3, 3, 1, 0],
    [0, 1, 1, 1, 1, 3, 3, 3, 3, 3, 1, 1, 1, 3, 1, 0],
    [0, 1, 3, 1, 3, 3, 3, 3, 3, 3, 3, 1, 3, 3, 1, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_DRAGON_EGG: PixelGrid = [
    // Egg - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 4, 4, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 4, 3, 3, 4, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 4, 3, 3, 4, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 4, 3, 3, 3, 3, 4, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 4, 3, 3, 3, 3, 4, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 4, 3, 3, 3, 3, 4, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 4, 3, 3, 3, 3, 4, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 4, 3, 3, 4, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 4, 4, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_UNIVERSE_MAP: PixelGrid = [
    // Map of the universe - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0],
    [0, 0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0],
    [0, 1, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 2, 1, 0],
    [0, 1, 2, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 1, 0],
    [0, 1, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 2, 1, 0],
    [0, 1, 2, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 1, 0],
    [0, 1, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 2, 1, 0],
    [0, 1, 2, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 1, 0],
    [0, 1, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 2, 1, 0],
    [0, 0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 0, 0],
    [0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_ANSWER_TO_EVERYTHING: PixelGrid = [
    // 42 - The Answer to Everything - 16x16 (Clear & Bold)
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 1, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 1, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0],
    [0, 0, 1, 1, 1, 1, 1, 0, 0, 1, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 1, 0, 1, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 1, 0, 1, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 1, 0, 1, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 0, 0, 1, 3, 1, 0, 1, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_HEART_OF_GALAXY: PixelGrid = [
    // Heart of the galaxy - 16x16
    [0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0],
    [0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0],
    [0, 0, 0, 1, 1, 0, 0, 3, 0, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 1, 4, 4, 1, 0, 0, 1, 4, 4, 1, 0, 0, 0, 0],
    [0, 1, 4, 3, 4, 3, 1, 1, 4, 3, 4, 3, 1, 0, 0, 0],
    [0, 1, 4, 3, 4, 3, 4, 3, 4, 3, 4, 3, 1, 0, 0, 0],
    [3, 1, 4, 3, 4, 3, 4, 3, 4, 3, 4, 3, 1, 3, 0, 0],
    [0, 1, 4, 3, 4, 3, 4, 3, 4, 3, 4, 3, 1, 0, 0, 0],
    [0, 0, 1, 4, 3, 4, 3, 4, 3, 4, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 4, 3, 4, 3, 4, 3, 1, 0, 0, 3, 0, 0],
    [0, 3, 0, 0, 1, 4, 3, 4, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 4, 3, 1, 0, 0, 0, 3, 0, 0, 0],
    [0, 0, 3, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_COSMIC_ASCENSION: PixelGrid = [
    // Cosmic ascension arrow - 16x16
    [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 4, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 4, 3, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 3, 4, 3, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 4, 3, 4, 3, 4, 3, 4, 1, 0, 0, 0, 0],
    [0, 0, 1, 4, 3, 4, 3, 4, 3, 4, 3, 4, 1, 0, 0, 0],
    [0, 3, 0, 0, 0, 0, 1, 4, 1, 0, 0, 0, 0, 3, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 4, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 3, 0, 0, 0, 1, 4, 1, 0, 0, 0, 3, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 4, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 3, 0, 0, 0, 0, 1, 4, 1, 0, 0, 0, 0, 3, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 4, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 3, 0, 0, 1, 4, 1, 0, 0, 3, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 4, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 3, 0, 0, 0, 1, 1, 1, 0, 0, 0, 3, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_MEANING_OF_LIFE: PixelGrid = [
    // Question mark/Galaxy - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 1, 1, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_MASTER_CLICKER: PixelGrid = [
    // Master clicker with crown - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 4, 1, 4, 1, 4, 1, 4, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 1, 4, 1, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 3, 4, 3, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 3, 4, 3, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 3, 4, 3, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 3, 4, 3, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 4, 3, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 2, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 2, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 2, 2, 2, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 2, 3, 2, 3, 2, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 2, 3, 2, 3, 2, 3, 2, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_CLICK_MULTIPLIER: PixelGrid = [
    // Cursor x3 - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 1, 0, 1, 3, 1, 0, 1, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 1, 1, 3, 3, 1, 1, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 1, 3, 3, 3, 1, 3, 3, 3, 1, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0],
    [0, 0, 1, 3, 3, 3, 1, 3, 3, 3, 1, 3, 3, 3, 1, 0],
    [0, 0, 1, 3, 3, 1, 1, 3, 3, 1, 1, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 1, 0, 1, 3, 1, 0, 1, 3, 1, 0, 0, 0],
    [0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_SUPER_CLICKER: PixelGrid = [
    // Super clicker ultimate with energy - 16x16
    [0, 0, 0, 0, 3, 0, 0, 1, 0, 0, 3, 0, 0, 0, 0, 0],
    [0, 0, 0, 3, 0, 0, 1, 4, 1, 0, 0, 3, 0, 0, 0, 0],
    [0, 0, 3, 0, 0, 1, 4, 3, 4, 1, 0, 0, 3, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 3, 4, 3, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 4, 3, 4, 3, 4, 3, 4, 1, 0, 0, 0, 0],
    [0, 3, 0, 1, 4, 3, 4, 3, 4, 3, 4, 1, 0, 3, 0, 0],
    [0, 0, 0, 1, 4, 3, 4, 3, 4, 3, 4, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 4, 3, 4, 3, 4, 3, 4, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 3, 4, 3, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 3, 0, 0, 1, 4, 3, 4, 1, 0, 0, 3, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 2, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 3, 0, 0, 1, 2, 1, 0, 0, 3, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 2, 2, 2, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 2, 3, 2, 3, 2, 1, 0, 0, 0, 0, 0],
    [0, 0, 3, 1, 2, 3, 2, 3, 2, 3, 2, 1, 3, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_MULTIVERSAL_MATRIX: PixelGrid = [
    // Matrix/Grid - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
    [0, 0, 1, 3, 3, 1, 3, 3, 1, 3, 3, 1, 3, 3, 1, 0],
    [0, 0, 1, 3, 3, 1, 3, 3, 1, 3, 3, 1, 3, 3, 1, 0],
    [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
    [0, 0, 1, 3, 3, 1, 3, 3, 1, 3, 3, 1, 3, 3, 1, 0],
    [0, 0, 1, 3, 3, 1, 3, 3, 1, 3, 3, 1, 3, 3, 1, 0],
    [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
    [0, 0, 1, 3, 3, 1, 3, 3, 1, 3, 3, 1, 3, 3, 1, 0],
    [0, 0, 1, 3, 3, 1, 3, 3, 1, 3, 3, 1, 3, 3, 1, 0],
    [0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_ENTROPY_REVERSAL: PixelGrid = [
    // Reverse arrows - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 1, 1, 1, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 3, 1, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0],
    [0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 1, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 1, 1, 1, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_OMNISCIENT_AI: PixelGrid = [
    // Eye/Chip - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 4, 4, 4, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 3, 4, 1, 1, 1, 4, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 4, 1, 3, 1, 4, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 4, 1, 1, 1, 4, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 4, 4, 4, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_BIG_BANG_GENERATOR: PixelGrid = [
    // Explosion - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 0, 1, 3, 1, 0, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 1, 3, 4, 3, 1, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 4, 4, 4, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 3, 4, 4, 4, 4, 4, 3, 1, 1, 0, 0, 0],
    [0, 0, 0, 3, 4, 4, 4, 4, 4, 4, 4, 3, 0, 0, 0, 0],
    [0, 0, 1, 1, 3, 4, 4, 4, 4, 4, 3, 1, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 4, 4, 4, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 1, 3, 4, 3, 1, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 0, 1, 3, 1, 0, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_DIMENSIONAL_COLLAPSE: PixelGrid = [
    // Implosion - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0],
    [0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 3, 4, 4, 4, 3, 0, 0, 0, 0, 0, 0],
    [0, 1, 1, 1, 1, 3, 4, 1, 4, 3, 1, 1, 1, 1, 0, 0],
    [0, 0, 0, 0, 0, 3, 4, 4, 4, 3, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0],
    [0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_REALITY_COMPILER: PixelGrid = [
    // Code/Binary - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0],
    [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0],
    [0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 0, 0],
    [0, 0, 1, 3, 1, 0, 1, 3, 1, 0, 1, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 1, 0, 1, 3, 1, 0, 1, 3, 1, 0, 0, 0],
    [0, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_AKASHIC_RECORDS: PixelGrid = [
    // Library/Scrolls - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 0, 0, 0],
    [0, 1, 3, 1, 0, 1, 3, 1, 0, 1, 3, 1, 0, 0, 0, 0],
    [0, 1, 3, 1, 0, 1, 3, 1, 0, 1, 3, 1, 0, 0, 0, 0],
    [0, 1, 3, 1, 0, 1, 3, 1, 0, 1, 3, 1, 0, 0, 0, 0],
    [0, 1, 3, 1, 0, 1, 3, 1, 0, 1, 3, 1, 0, 0, 0, 0],
    [0, 1, 3, 1, 0, 1, 3, 1, 0, 1, 3, 1, 0, 0, 0, 0],
    [0, 1, 3, 1, 0, 1, 3, 1, 0, 1, 3, 1, 0, 0, 0, 0],
    [0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_VOID_HEART: PixelGrid = [
    // Dark Heart - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 1, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 1, 4, 4, 1, 0, 0, 1, 4, 4, 1, 0, 0, 0, 0],
    [0, 1, 4, 4, 4, 4, 1, 1, 4, 4, 4, 4, 1, 0, 0, 0],
    [0, 1, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 1, 0, 0, 0],
    [0, 1, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 1, 0, 0, 0],
    [0, 1, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 1, 0, 0, 0],
    [0, 0, 1, 4, 4, 4, 4, 4, 4, 4, 4, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 4, 4, 4, 4, 4, 4, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 4, 4, 4, 4, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 4, 4, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_ETERNAL_ENGINE: PixelGrid = [
    // Infinity Gears - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 1, 3, 3, 3, 3, 1, 1, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 1, 3, 4, 4, 3, 1, 1, 3, 4, 4, 3, 1, 0, 0, 0],
    [0, 1, 3, 4, 4, 3, 1, 1, 3, 4, 4, 3, 1, 0, 0, 0],
    [0, 1, 3, 3, 3, 3, 1, 1, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_OMEGA_PROTOCOL: PixelGrid = [
    // Omega symbol - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 1, 1, 1, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 1, 0, 1, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 1, 0, 1, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 1, 0, 1, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 1, 3, 1, 0, 1, 3, 1, 1, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_INFINITY_ENGINE: PixelGrid = [
    // Infinite Engine - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 1, 1, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 1, 3, 4, 4, 3, 1, 1, 3, 4, 4, 3, 1, 0, 0],
    [0, 0, 1, 3, 4, 4, 3, 1, 1, 3, 4, 4, 3, 1, 0, 0],
    [0, 0, 1, 3, 3, 3, 1, 3, 3, 1, 3, 3, 3, 1, 0, 0],
    [0, 0, 0, 1, 1, 1, 3, 4, 4, 3, 1, 1, 1, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 4, 4, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 4, 4, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 1, 1, 3, 4, 4, 3, 1, 1, 1, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 1, 3, 3, 1, 3, 3, 3, 1, 0, 0],
    [0, 0, 1, 3, 4, 4, 3, 1, 1, 3, 4, 4, 3, 1, 0, 0],
    [0, 0, 1, 3, 4, 4, 3, 1, 1, 3, 4, 4, 3, 1, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 1, 1, 3, 3, 3, 1, 0, 0, 0],
    [0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_UNIVERSE_SEED: PixelGrid = [
    // Seed/Sprout - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const UPGRADE_SPRITE_TRANSCENDENCE: PixelGrid = [
    // Ascension/Light - 16x16
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 1, 3, 1, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 1, 3, 3, 3, 1, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 1, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0, 0],
    [0, 0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0, 0],
    [0, 0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0, 0],
    [0, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

export const getUpgradeSprite = (id: string): PixelGrid | null => {
    switch (id) {
        case 'stellar_forge': return UPGRADE_SPRITE_STELLAR_FORGE;
        case 'golden_goose': return UPGRADE_SPRITE_GOLDEN_GOOSE;
        case 'dark_matter_engine': return UPGRADE_SPRITE_DARK_MATTER_ENGINE;
        case 'ship': return UPGRADE_SPRITE_SHIP;
        case 'attackSpeed': return UPGRADE_SPRITE_ATTACK_SPEED;
        case 'pointMultiplier': return UPGRADE_SPRITE_POINT_MULTIPLIER;
        case 'critChance': return UPGRADE_SPRITE_CRIT_CHANCE;
        case 'resourceGen': return UPGRADE_SPRITE_RESOURCE_GEN;
        case 'xpBoost': return UPGRADE_SPRITE_XP_BOOST;
        case 'mutationEngine': return UPGRADE_SPRITE_MUTATION_ENGINE;
        case 'energyCore': return UPGRADE_SPRITE_ENERGY_CORE;
        case 'cosmicKnowledge': return UPGRADE_SPRITE_COSMIC_KNOWLEDGE;
        case 'misc': return UPGRADE_SPRITE_MISC;
        case 'antimatter_cascade': return UPGRADE_SPRITE_ANTIMATTER_CASCADE;
        case 'infinity_gauntlet': return UPGRADE_SPRITE_INFINITY_GAUNTLET;
        case 'nebula_harvester': return UPGRADE_SPRITE_NEBULA_HARVESTER;
        case 'alien_cookbook': return UPGRADE_SPRITE_ALIEN_COOKBOOK;
        case 'hyper_reactor': return UPGRADE_SPRITE_HYPER_REACTOR;
        case 'fleet_command_center': return UPGRADE_SPRITE_FLEET_COMMAND_CENTER;
        case 'quantum_singularity': return UPGRADE_SPRITE_QUANTUM_SINGULARITY;
        case 'armada_command': return UPGRADE_SPRITE_ARMADA_COMMAND;
        case 'chronos_accelerator': return UPGRADE_SPRITE_CHRONOS_ACCELERATOR;
        case 'perfect_critical': return UPGRADE_SPRITE_PERFECT_CRITICAL;
        case 'infinite_knowledge': return UPGRADE_SPRITE_INFINITE_KNOWLEDGE;
        case 'nuclear_reactor': return UPGRADE_SPRITE_NUCLEAR_REACTOR;
        case 'photon_amplifier': return UPGRADE_SPRITE_PHOTON_AMPLIFIER;
        case 'reality_anchor': return UPGRADE_SPRITE_REALITY_ANCHOR;
        case 'cosmic_battery': return UPGRADE_SPRITE_COSMIC_BATTERY;
        case 'singularity_core': return UPGRADE_SPRITE_SINGULARITY_CORE;
        case 'cheat_codes': return UPGRADE_SPRITE_CHEAT_CODES;
        case 'dragon_egg': return UPGRADE_SPRITE_DRAGON_EGG;
        case 'universe_map': return UPGRADE_SPRITE_UNIVERSE_MAP;
        case 'answer_to_everything': return UPGRADE_SPRITE_ANSWER_TO_EVERYTHING;
        case 'heart_of_galaxy': return UPGRADE_SPRITE_HEART_OF_GALAXY;
        case 'cosmic_ascension': return UPGRADE_SPRITE_COSMIC_ASCENSION;
        case 'meaning_of_life': return UPGRADE_SPRITE_MEANING_OF_LIFE;
        case 'master_clicker': return UPGRADE_SPRITE_MASTER_CLICKER;
        case 'click_multiplier': return UPGRADE_SPRITE_CLICK_MULTIPLIER;
        case 'super_clicker': return UPGRADE_SPRITE_SUPER_CLICKER;
        case 'multiversal_matrix': return UPGRADE_SPRITE_MULTIVERSAL_MATRIX;
        case 'entropy_reversal': return UPGRADE_SPRITE_ENTROPY_REVERSAL;
        case 'omniscient_ai': return UPGRADE_SPRITE_OMNISCIENT_AI;
        case 'big_bang_generator': return UPGRADE_SPRITE_BIG_BANG_GENERATOR;
        case 'dimensional_collapse': return UPGRADE_SPRITE_DIMENSIONAL_COLLAPSE;
        case 'reality_compiler': return UPGRADE_SPRITE_REALITY_COMPILER;
        case 'akashic_records': return UPGRADE_SPRITE_AKASHIC_RECORDS;
        case 'void_heart': return UPGRADE_SPRITE_VOID_HEART;
        case 'eternal_engine': return UPGRADE_SPRITE_ETERNAL_ENGINE;
        case 'omega_protocol': return UPGRADE_SPRITE_OMEGA_PROTOCOL;
        case 'infinity_engine': return UPGRADE_SPRITE_INFINITY_ENGINE;
        case 'universe_seed': return UPGRADE_SPRITE_UNIVERSE_SEED;
        case 'transcendence': return UPGRADE_SPRITE_TRANSCENDENCE;
        case 'ai_optimizer': return UPGRADE_SPRITE_AI_OPTIMIZER;
        case 'lucky_horseshoe': return UPGRADE_SPRITE_LUCKY_HORSESHOE;
        case 'perfect_precision': return UPGRADE_SPRITE_PERFECT_PRECISION;
        case 'arcade_machine': return UPGRADE_SPRITE_ARCADE_MACHINE;
        case 'void_channeling': return UPGRADE_SPRITE_VOID_CHANNELING;
        case 'chaos_emeralds': return UPGRADE_SPRITE_CHAOS_EMERALDS;
        case 'time_machine': return UPGRADE_SPRITE_TIME_MACHINE;
        case 'nanobots': return UPGRADE_SPRITE_NANOBOTS;
        case 'plasma_matrix': return UPGRADE_SPRITE_PLASMA_MATRIX;
        case 'holographic_decoys': return UPGRADE_SPRITE_HOLOGRAPHIC_DECOYS;
        case 'temporal_acceleration': return UPGRADE_SPRITE_TEMPORAL_ACCELERATION;
        case 'quantum_entanglement': return UPGRADE_SPRITE_QUANTUM_ENTANGLEMENT;
        case 'philosophers_stone': return UPGRADE_SPRITE_PHILOSOPHERS_STONE;
        case 'death_pact': return UPGRADE_SPRITE_DEATH_PACT;
        case 'laser_focusing': return UPGRADE_SPRITE_LASER_FOCUSING;
        case 'amplified_resonance': return UPGRADE_SPRITE_AMPLIFIED_RESONANCE;
        case 'quantum_network_matrix': return UPGRADE_SPRITE_QUANTUM_NETWORK_MATRIX;
        case 'enhanced_combat_matrix': return UPGRADE_SPRITE_ENHANCED_COMBAT_MATRIX;
        case 'knowledge_power_conversion': return UPGRADE_SPRITE_KNOWLEDGE_POWER_CONVERSION;
        case 'coffee_machine': return UPGRADE_SPRITE_COFFEE_MACHINE;
        case 'quantum_targeting': return UPGRADE_SPRITE_QUANTUM_TARGETING;
        case 'lucky_dice': return UPGRADE_SPRITE_LUCKY_DICE;
        case 'energy_recycling': return UPGRADE_SPRITE_ENERGY_RECYCLING;
        case 'overclocked_reactors': return UPGRADE_SPRITE_OVERCLOCKED_REACTORS;
        case 'ship_swarm': return UPGRADE_SPRITE_SHIP_SWARM;
        case 'fleet_synergy_matrix': return UPGRADE_SPRITE_FLEET_SYNERGY_MATRIX;
        case 'quantum_fleet_sync': return UPGRADE_SPRITE_QUANTUM_FLEET_SYNC;
        case 'stellar_fusion_core': return UPGRADE_SPRITE_STELLAR_FUSION_CORE;
        case 'hyper_network_accelerator': return UPGRADE_SPRITE_HYPER_NETWORK_ACCELERATOR;
        case 'fleet_omega_core': return UPGRADE_SPRITE_FLEET_OMEGA_CORE;
        case 'critical_mastery': return UPGRADE_SPRITE_CRITICAL_MASTERY;
        case 'dual_network_expansion': return UPGRADE_SPRITE_DUAL_NETWORK_EXPANSION;
        case 'network_white_glow': return UPGRADE_SPRITE_NETWORK_WHITE_GLOW;
        case 'crimson_network_protocol': return UPGRADE_SPRITE_CRIMSON_NETWORK_PROTOCOL;
        case 'void_essence_core': return UPGRADE_SPRITE_VOID_ESSENCE_CORE;
        case 'orbital_satellite': return UPGRADE_SPRITE_ORBITAL_SATELLITE;
        case 'rapid_fire_satellite': return UPGRADE_SPRITE_RAPID_FIRE_SATELLITE;
        case 'cosmic_synergy_matrix': return UPGRADE_SPRITE_COSMIC_SYNERGY_MATRIX;
        case 'fleet_xp_synergy': return UPGRADE_SPRITE_FLEET_XP_SYNERGY;
        case 'neural_link': return UPGRADE_SPRITE_NEURAL_LINK;
        case 'space_pizza': return UPGRADE_SPRITE_SPACE_PIZZA;
        case 'rubber_duck': return UPGRADE_SPRITE_RUBBER_DUCK;
        case 'falafel_rollo_special': return UPGRADE_SPRITE_FALAFEL_ROLLO_SPECIAL;
        case 'antimatter_rounds': return UPGRADE_SPRITE_ANTIMATTER_ROUNDS;
        case 'motivational_posters': return UPGRADE_SPRITE_MOTIVATIONAL_POSTERS;
        case 'warp_core': return UPGRADE_SPRITE_WARP_CORE;
        case 'disco_ball': return UPGRADE_SPRITE_DISCO_BALL;
        case 'adaptive_evolution': return UPGRADE_SPRITE_ADAPTIVE_EVOLUTION;
        case 'symbiotic_weapons': return UPGRADE_SPRITE_SYMBIOTIC_WEAPONS;
        case 'regenerative_hull': return UPGRADE_SPRITE_REGENERATIVE_HULL;
        case 'hive_mind': return UPGRADE_SPRITE_HIVE_MIND;
        case 'perfect_organism': return UPGRADE_SPRITE_PERFECT_ORGANISM;
        case 'eldritch_evolution': return UPGRADE_SPRITE_ELDRITCH_EVOLUTION;
        case 'cosmic_horror': return UPGRADE_SPRITE_COSMIC_HORROR;
        case 'transcendent_form': return UPGRADE_SPRITE_TRANSCENDENT_FORM;
        case 'living_weapon': return UPGRADE_SPRITE_LIVING_WEAPON;
        case 'apex_predator': return UPGRADE_SPRITE_APEX_PREDATOR;
        case 'fusion_reactor': return UPGRADE_SPRITE_FUSION_REACTOR;
        case 'zero_point': return UPGRADE_SPRITE_ZERO_POINT;
        case 'perpetual_motion': return UPGRADE_SPRITE_PERPETUAL_MOTION;
        case 'tesla_coils': return UPGRADE_SPRITE_TESLA_COILS;
        case 'arc_reactor': return UPGRADE_SPRITE_ARC_REACTOR;
        case 'harvested_star': return UPGRADE_SPRITE_HARVESTED_STAR;
        case 'vacuum_energy_tap': return UPGRADE_SPRITE_VACUUM_ENERGY_TAP;
        case 'entropy_reversal_engine': return UPGRADE_SPRITE_ENTROPY_REVERSAL_ENGINE;
        case 'big_crunch_generator': return UPGRADE_SPRITE_BIG_CRUNCH_GENERATOR;
        case 'multiversal_tap': return UPGRADE_SPRITE_MULTIVERSAL_TAP;
        case 'ancient_texts': return UPGRADE_SPRITE_ANCIENT_TEXTS;
        case 'akashic_records_library': return UPGRADE_SPRITE_AKASHIC_RECORDS_LIBRARY;
        case 'prophetic_vision': return UPGRADE_SPRITE_PROPHETIC_VISION;
        case 'universal_translator': return UPGRADE_SPRITE_UNIVERSAL_TRANSLATOR;
        case 'omniscience_lite': return UPGRADE_SPRITE_OMNISCIENCE_LITE;
        case 'forbidden_theorems': return UPGRADE_SPRITE_FORBIDDEN_THEOREMS;
        case 'schrodinger_upgrade': return UPGRADE_SPRITE_SCHRODINGER_UPGRADE;
        case 'universal_constants': return UPGRADE_SPRITE_UNIVERSAL_CONSTANTS;
        case 'apotheosis': return UPGRADE_SPRITE_APOTHEOSIS;
        case 'omniscience': return UPGRADE_SPRITE_OMNISCIENCE;
        case 'dimensional_rift':
            return UPGRADE_SPRITE_DIMENSIONAL_RIFT;
        case 'void_prism':
            return UPGRADE_SPRITE_VOID_PRISM;
        case 'chronal_dust':
            return UPGRADE_SPRITE_CHRONAL_DUST;
        case 'dark_matter_weaver':
            return UPGRADE_SPRITE_DARK_MATTER_WEAVER;
        case 'entropy_injector':
            return UPGRADE_SPRITE_ENTROPY_INJECTOR;
        case 'temporal_siphon':
            return UPGRADE_SPRITE_TEMPORAL_SIPHON;
        case 'event_horizon_shield':
            return UPGRADE_SPRITE_EVENT_HORIZON_SHIELD;
        case 'cosmic_filament':
            return UPGRADE_SPRITE_COSMIC_FILAMENT;
        case 'null_space_projector':
            return UPGRADE_SPRITE_NULL_SPACE_PROJECTOR;
        case 'omega_relay':
            return UPGRADE_SPRITE_OMEGA_RELAY;
        default:
            return null;
    }
};
